/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum StockSortField {
  MARKET_CAP = "MARKET_CAP",
  PRICE_CHANGE_PERCENTAGE = "PRICE_CHANGE_PERCENTAGE",
  PRICE_CHANGE_PERCENTAGE_YTD = "PRICE_CHANGE_PERCENTAGE_YTD",
  IPO_TIME = "IPO_TIME",
  OVERALL_SCORE = "OVERALL_SCORE",
  P1_VALUATION = "P1_VALUATION",
  P2_PROFITABILITY = "P2_PROFITABILITY",
  P3_GROWTH = "P3_GROWTH",
  P4_FINANCIAL_HEALTH = "P4_FINANCIAL_HEALTH",
  P5_MOMENTUM_SENTIMENT = "P5_MOMENTUM_SENTIMENT",
  P6_SHAREHOLDER_RETURN = "P6_SHAREHOLDER_RETURN",
  P7_RISK_PROFILE = "P7_RISK_PROFILE",
  P8_TECHNICAL_CONDITION = "P8_TECHNICAL_CONDITION",
  E1_COST_STRUCTURE = "E1_COST_STRUCTURE",
  E2_PERFORMANCE_MOMENTUM = "E2_PERFORMANCE_MOMENTUM",
  E3_TRACKING_QUALITY = "E3_TRACKING_QUALITY",
  E4_DISTRIBUTION = "E4_DISTRIBUTION",
  E5_RISK_PROFILE = "E5_RISK_PROFILE",
}

/**
 * Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months
 * @default "quarterly"
 */
export enum FinancialFrequency {
  Quarterly = "quarterly",
  Annual = "annual",
  Ttm = "ttm",
}

export enum TokenSortField {
  MARKET_CAP = "MARKET_CAP",
  VOLUME = "VOLUME",
  ID = "ID",
  VOL_24H_USDT = "VOL_24H_USDT",
  PRICE_CHANGE_1H = "PRICE_CHANGE_1H",
  PRICE_CHANGE_24H = "PRICE_CHANGE_24H",
  PRICE_CHANGE_7D = "PRICE_CHANGE_7D",
  TURNOVER_RATE = "TURNOVER_RATE",
  LISTING_TIME = "LISTING_TIME",
  OVERALL_SCORE = "OVERALL_SCORE",
  C1_VALUATION = "C1_VALUATION",
  C2_ON_CHAIN_ACTIVITY = "C2_ON_CHAIN_ACTIVITY",
  C3_GROWTH_ADOPTION = "C3_GROWTH_ADOPTION",
  C4_PROTOCOL_HEALTH = "C4_PROTOCOL_HEALTH",
  C5_MOMENTUM_SENTIMENT = "C5_MOMENTUM_SENTIMENT",
  C6_TOKEN_ECONOMICS = "C6_TOKEN_ECONOMICS",
  C7_RISK_PROFILE = "C7_RISK_PROFILE",
  C8_TECHNICAL_CONDITION = "C8_TECHNICAL_CONDITION",
}

/** content category */
export enum ContentFormatTypeEnum {
  PLAIN_TEXT = "PLAIN_TEXT",
  RICH_CONTENT = "RICH_CONTENT",
}

/** stock market state */
export enum StockMarketStateEnum {
  CLOSED_MARKET = "CLOSED_MARKET",
  PRE_MARKET = "PRE_MARKET",
  REGULAR_MARKET = "REGULAR_MARKET",
  POST_MARKET = "POST_MARKET",
  AUCTION = "AUCTION",
  NIGHT_MARKET = "NIGHT_MARKET",
}

/** stock market */
export enum StockMarketEnum {
  US = "US",
  HK = "HK",
}

/** content type */
export enum PortfolioAssetTypeEnum {
  TOKEN = "TOKEN",
  STOCK = "STOCK",
}

/** open data type */
export enum OpenDataTypeEnum {
  PEOPLE = "PEOPLE",
  CONTENT = "CONTENT",
  ECOSYSTEM = "ECOSYSTEM",
  PROJECT = "PROJECT",
  TOKEN = "TOKEN",
  POOL = "POOL",
  STOCK = "STOCK",
  THEME = "THEME",
}

/** Fractal Point type */
export enum FractalPointTypeEnum {
  BEARISH_FRACTAL = "BEARISH_FRACTAL",
  BULLISH_FRACTAL = "BULLISH_FRACTAL",
}

/** exchange name */
export enum ExchangeEnum {
  BINANCE = "BINANCE",
  UPBIT = "UPBIT",
  COINBASE = "COINBASE",
}

/** content type */
export enum ContentTypeEnum {
  NEWS = "NEWS",
  POST = "POST",
  EARNING_CALENDAR = "EARNING_CALENDAR",
  FLASH = "FLASH",
  NEWS_RECOMMEND = "NEWS_RECOMMEND",
  INSIGHT = "INSIGHT",
  ARTICLE = "ARTICLE",
}

/** category */
export enum ContentCategoryEnum {
  CRYPTO = "CRYPTO",
  STOCK = "STOCK",
}

/** Average Directional Index */
export interface ADX {
  values?: number[];
}

/** Add to Portfolio Asset request parameters */
export interface AddPortfolioAssetRequest {
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id: string;
  /**
   * Asset type
   * @example "TOKEN"
   */
  asset_type: "TOKEN" | "STOCK";
  /**
   * Portfolio IDs
   * @maxItems 30
   */
  portfolio_ids?: string[];
}

/** Bollinger Bands */
export interface BBands {
  /** The upper limit of price fluctuation for Bollinger Bands. */
  upper_band?: number[];
  /** The middle reference line of Bollinger Bands. */
  middle_band?: number[];
  /** The lower limit of price fluctuation for Bollinger Bands. */
  lower_band?: number[];
  /** The width between the upper and lower bands of Bollinger Bands. */
  band_width?: number;
}

export interface BaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: object;
  errors?: Error[];
}

/** Commodity Channel Index */
export interface CCI {
  values?: number[];
}

export interface PeopleEnrichOption {
  /**
   * If you need to return the people relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * fill x's posts count
   * @min 0
   * @max 20
   * @default 0
   */
  with_x_content_count?: number;
  /** include some social metrics, such as ... */
  with_social_metrics?: boolean;
}

export interface PeoplePagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** @format int32 */
  offset?: number;
  rows?: People[];
}

export type PeoplePaginationResponse = BaseResponse & {
  data?: PeoplePagination;
};

/** content info */
export interface Content {
  /** The CONTENT ID */
  id?: string;
  /** The ID of the author of the content */
  people_id?: string;
  /** content title */
  title?: string;
  /** content body */
  content?: string;
  /** summary for language */
  summary?: string;
  /** description for language */
  description?: string;
  /** content category */
  format_type?: ContentFormatTypeEnum;
  medias?: Media[];
  /**
   * create time
   * @format int64
   */
  created?: number;
  /** The list of mention contained in the post */
  mentions?: {
    /** mention name */
    id?: string;
    /** mention handle */
    handle?: string;
    /** mention avatar */
    avatar?: string;
  }[];
  /** The list of symbol contained in the post */
  symbols?: {
    /** symbol name */
    symbol?: string;
    /** symbol id */
    id?: string;
    /** sentiment type eg BULLISH|BEARISH|NEUTRAL */
    sentiment?: string;
    /** symbol logo */
    logo?: string;
    /** market */
    market?: string;
    /** stock short name */
    short_name?: string;
    /** coin price change 24h */
    price_change_24h?: number;
    /** The current price of the stock */
    current_price?: number;
    /** The previous close price of the stock */
    previous_close?: number;
  }[];
  /** The name of the post platform */
  platform?: string;
  /** The ID of the post on the external platform */
  platform_id?: string;
  /** people info */
  author?: People;
  /** source link */
  source_link?: string;
  /**
   * issue date
   * @format int64
   */
  issue_date?: number;
  /** people tags */
  tags?: string[];
  earning_calendar?: EarningsCalendar;
  /** post other properties */
  properties?: object;
  themes?: string[];
  /** content theme ids */
  theme_ids?: string[];
  /** content categories */
  categories?: ContentCategoryEnum[];
  questions?: string[];
  /** agent id */
  agent_id?: string;
}

export interface ContentSymbolEnrichOption {
  /**
   * If you need to return the post relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** @default false */
  with_price?: boolean;
}

export interface ContentEnrichOption {
  /**
   * If you need to return the post relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  with_people?: PeopleEnrichOption;
  with_symbol?: ContentSymbolEnrichOption;
}

export interface ContentPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** @format int32 */
  offset?: number;
  rows?: Content[];
}

export type ContentPaginationResponse = BaseResponse & {
  data?: ContentPagination;
};

/** Create portfolio request parameters */
export interface CreatePortfolioRequest {
  /**
   * Portfolio name
   * @example "My Investment Portfolio"
   */
  name: string;
}

/** Detrended Price Oscillator */
export interface DPO {
  values?: number[];
}

/** Delete portfolio request parameters */
export interface DeletePortfolioRequest {
  /**
   * Portfolio ID
   * @example "12345"
   */
  id: string;
}

/** Exponential Moving Average */
export interface EMA {
  values?: number[];
  /** @format int32 */
  time_period?: number;
}

export interface EarningsCalendar {
  /** Actual EPS */
  eps_actual?: number;
  /** Estimated EPS */
  eps_estimate?: number;
  /** Hour */
  hour?: string;
  /** Quarter */
  quarter?: string;
  /** Actual Revenue */
  revenue_actual?: number;
  /** Estimated Revenue */
  revenue_estimate?: number;
  /**
   * Year
   * @format int32
   */
  year?: number;
  /** Logo */
  logo?: string;
  /** Company Name */
  company_name?: string;
  /** earnings date */
  date?: string;
}

export interface MarketMetricsRequest {
  with_altcoin_index?: boolean;
  with_fear_and_greed_index?: boolean;
  with_dominance?: boolean;
  /** @deprecated */
  with_index_trading_data?: string[];
}

export type MarketMetricsResponse = BaseResponse & {
  data?: MarketMetrics;
};

export interface MarketMetricsLatest {
  /**
   * Altcoin Index (0-100, based on market performance).
   * @example 72.5
   */
  altcoin_index?: number;
  /**
   * Fear and Greed Index (0-100, 0=extreme fear, 100=extreme greed).
   * @example 65
   */
  fear_and_greed_index?: number;
  /**
   * Bitcoin Dominance (% of total crypto market cap).
   * @example 56.7
   */
  btc_dominance?: number;
  /** Ethereum Dominance (% of total crypto market cap). */
  eth_dominance?: number;
  /** Bitcoin Dominance (% of total crypto market cap). */
  btc_dominance_24h_percentage_change?: number;
  /** Ethereum Dominance (% of total crypto market cap). */
  eth_dominance_24h_percentage_change?: number;
  /**
   * Unix timestamp of the data.
   * @format int64
   * @example 1698765432
   */
  timestamp?: number;
  /**
   * Formatted timestamp based on date_format parameter.
   * @example "2025/07/30"
   */
  last_updated?: string;
}

export interface MarketMetrics {
  market_metrics_latest?: MarketMetricsLatest;
}

/** network info */
export interface Ecosystem {
  /**
   * network id
   * @example "ethereum, bitcoin"
   */
  id?: string;
  /** network name */
  name?: string;
  /** network display name */
  display_name?: string;
  /** network alias names */
  aliases?: string[];
  /** network tags */
  tags?: string[];
  /** network logo image */
  logo?: string;
  /** people detailed desc */
  desc?: string;
  /** network info */
  network?: OnChainNetwork;
  tvls?: Tvl[];
  /** network other properties */
  properties?: object;
  /** token info */
  token?: Token;
  /** people social media info */
  social_media?: OpenSocialMedia;
  data_sources?: OpenDataSource[];
}

export interface EcosystemPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** @format int32 */
  offset?: number;
  rows?: Ecosystem[];
}

export type EcosystemPaginationResponse = BaseResponse & {
  data?: EcosystemPagination;
};

export interface Error {
  /** error type, eg. Generic, InvalidRequest, ClientForbidden */
  reason?: string;
  /** human-friendly message */
  detail?: string;
  /** chart */
  location?: string;
  /** parameter */
  locationType?: string;
}

/** Exchange flow */
export interface ExchangeFlow {
  /** time period, eg. 1d, 7d, 30d */
  time_period?: string;
  /** netflow */
  netflow?: number;
  /** inflow */
  inflow?: number;
  /** outflow */
  outflow?: number;
}

/** Fractal Point */
export interface FractalPoint {
  /** Pivot Point central value of index */
  index?: number;
  /**
   * timestamp of Pivot Points
   * @format int64
   */
  time?: number;
  /** price of Pivot Points */
  price?: number;
  /** Fractal Point type */
  type?: FractalPointTypeEnum;
}

/** Token holder information */
export interface Holder {
  /** Token holder count */
  count?: number;
  distribution_percentage?: number[];
  /** Token top holder list */
  top_holders?: {
    /** Token holder address */
    address?: string;
    /** Token holder amount */
    amount?: number;
    /** Token holder amount percentage */
    percentage?: number;
    /** Token holder label */
    label?: string;
    /** Token holder rank */
    rank?: number;
    /** Token holder amount usd value */
    value?: number;
  }[];
}

/** Moving Average */
export interface MA {
  values?: number[];
  /** @format int32 */
  time_period?: number;
}

/** Moving Average Convergence/Divergence */
export interface MACD {
  /** The value of the MACD line calculated from two exponential moving averages. */
  macd?: number[];
  /** The value of the signal line, a moving average of the MACD line. */
  signal?: number[];
  /** The difference between the MACD line and the signal line. */
  histogram?: number[];
}

/** token market data */
export interface MarketData {
  /** token current price in currency */
  current_price?: number;
  /** market cap */
  market_cap?: number;
  /** market cap change 24h */
  market_cap_change_24h?: number;
  /**
   * market cap change percentage 24h
   * @format double
   */
  market_cap_change_percentage_24h?: number;
  /** coin 24hr price high in currency */
  high_24h?: number;
  /** coin 24hr price low in currency */
  low_24h?: number;
  /** coin total trading volume in currency，eg:24h */
  volume_24h?: number;
  /** transaction count in 24h */
  txns_24h?: number;
  /** coin price change 24h */
  price_change_24h?: number;
  /**
   * coin price change percentage 24h
   * @format double
   */
  price_change_percentage_24h?: number;
  /** coin roi */
  roi?: number;
  /**
   * last updated time
   * @format int64
   */
  last_updated?: number;
  /** coin ath */
  ath?: number;
  /** coin atl */
  atl?: number;
  /**
   * coin ath change percentage
   * @format double
   */
  ath_change_percentage?: number;
  /**
   * coin atl change percentage
   * @format double
   */
  atl_change_percentage?: number;
  /** coin price change percentage 7d in currency */
  price_change_percentage?: PriceChangePercentage[];
  /** coin fdv */
  fdv?: number;
  /** pool liquidity */
  liquidity?: number;
  /** pool liquidity */
  marker_24h?: number;
  /** The lowest price in the last 52 weeks */
  low_52_w?: number;
  /** The highest price in the last 52 weeks */
  high_52_w?: number;
}

/** market pair info */
export interface MarketPair {
  /** market pair id */
  id?: string;
  /** base token symbol */
  base?: string;
  /** quote token symbol */
  quote?: string;
  /** base token name */
  base_name?: string;
  /** quote token name */
  quote_name?: string;
  /** logo */
  logo?: string;
  /** token market data */
  market_data?: MarketData;
  ohlc?: OHLC[];
  ema?: EMA[];
  rsi?: RSI[];
  fractal_point?: FractalPoint[];
  /** Moving Average Convergence/Divergence */
  macd?: MACD;
  /** A map where the key is a string (e.g., date or category) and the value is a list of VolumeDTO objects */
  volumes?: Record<string, PairVolume[]>;
  /**
   * trade data last updated time
   * @format int64
   */
  last_updated?: number;
}

export interface MarketPairPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** page offset */
  offset?: string;
  rows?: MarketPair[];
}

export type MarketPairPaginationResponse = BaseResponse & {
  data?: MarketPairPagination;
};

export type MarketPairResponse = BaseResponse & {
  /** market pair info */
  data?: MarketPair;
};

export interface Media {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  mime_type?: string;
  /** cover url */
  cover?: string;
}

/** OLHC info */
export interface OHLC {
  /**
   * timestamp of OLHC
   * @format int64
   */
  time?: number;
  /** open price of OLHC */
  open?: number;
  /** high price of OLHC */
  high?: number;
  /** low price of OLHC */
  low?: number;
  /** close price of OLHC */
  close?: number;
  /** volume of OLHC */
  volume?: number;
  /** volume of OLHC in USD */
  volume_usd?: number;
}

/** network info */
export interface OnChainNetwork {
  /**
   * network id
   * @example "ethereum, bitcoin"
   */
  id?: string;
  /** network name */
  name?: string;
  /** network display name */
  display_name?: string;
  /**
   * chain id if network is evm chain
   * @example "1, 8453"
   */
  chain_id?: number;
  /** network alias names */
  aliases?: string[];
  /** network tags */
  tags?: string[];
  /** network logo image */
  logo?: string;
  /** people detailed desc */
  desc?: string;
  /** network other properties */
  properties?: object;
}

export interface OnChainNetworkAddress {
  /** network id of token address */
  network_id?: string;
  /** network name of token address */
  network_name?: string;
  /** network logo of token address */
  network_logo?: string;
  /** chain id of token address */
  chain_id?: string;
  /** token address */
  address?: string;
}

/** query condition */
export interface OpenDataQueryCondition {
  /** condition key */
  key?: string;
  /** condition value */
  value?: string;
  operator?: "EQUAL" | "LIKE";
}

/** data source */
export interface OpenDataSource {
  id?: string;
  name?: string;
  platform?: string;
  link?: string;
}

/** people social media info */
export interface OpenSocialMedia {
  website?: string;
  twitter?: string;
  telegram?: string;
  discord?: string;
  linkedin?: string;
  facebook?: string;
  reddit?: string;
  slack?: string;
  github?: string;
  medium?: string;
}

/** Represents volume-related data for a specific date or entity */
export interface PairVolume {
  /**
   * The date associated with the volume data (e.g., '2023-10-01')
   * @example "2023-10-01"
   */
  date?: string;
  /**
   * The volume value for the specific date or entity
   * @example "1000"
   */
  volume?: string;
  /**
   * The total volume accumulated
   * @example "5000"
   */
  totalVolume?: string;
  /**
   * The ratio of volume to a reference value
   * @example "0.2"
   */
  ratio?: string;
  /**
   * The growth rate or change in volume
   * @example "10%"
   */
  growth?: string;
}

/** people info */
export interface People {
  /** id */
  id?: string;
  /** people display_name */
  display_name?: string;
  /** unique handle */
  handle?: string;
  /** alias names */
  aliases?: string[];
  /** people tags */
  tags?: string[];
  /** people avatar */
  avatar?: string;
  /** people detailed desc */
  desc?: string;
  /** people one-liner */
  oneliner?: string;
  /** team member roles or positions or jobs if people in organization */
  roles?: string[];
  /** all members if type is organization (company, exchange) */
  members?: {
    /** people id of the member */
    id?: string;
    /** people roles of the member */
    role?: string[];
  }[];
  /** people type */
  type?: "COMPANY" | "EXCHANGE" | "PERSON";
  /** people social metrics */
  social_metric?: SocialMetrics;
  contents?: Content[];
  /** people social media info */
  social_media?: OpenSocialMedia;
  /** the time when the person joined the organization or team */
  joined_at?: string;
}

/** pool info */
export interface Pool {
  /** id */
  id?: string;
  /** pool logo image */
  logo?: string;
  /** pool pair */
  pair?: string;
  /** base symbol of pool */
  base_symbol?: string;
  /** quote symbol of pool */
  quote_symbol?: string;
  /** base address of pool */
  base_address?: string;
  /** quote address of pool */
  quote_address?: string;
  /** dex id of pool */
  dex_id?: string;
  /** dex name of pool */
  dex_name?: string;
  /** dex logo of pool */
  dex_logo?: string;
  /** pool address */
  address?: string;
  /** network id of pool */
  network_id?: string;
  /** chain id of pool */
  chain_id?: string;
  /**
   * issue date
   * @format int64
   */
  issue_date?: number;
  /** base token name */
  name?: string;
  /** token market data */
  market_data?: MarketData;
  ohlc?: OHLC[];
  /** people social media info */
  social_media?: OpenSocialMedia;
}

export interface PoolPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: Pool[];
}

export type PoolPaginationResponse = BaseResponse & {
  data?: PoolPagination;
};

/** Portfolio Asset item structure */
export interface PortfolioAsset {
  /**
   * owner ID
   * @example "user123"
   */
  owner_id?: string;
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id?: string;
  /**
   * Asset type
   * @example "TOKEN"
   */
  asset_type?: "TOKEN" | "STOCK";
  /** Portfolio IDs */
  portfolios?: any[];
  /**
   * Asset name
   * @example "Bitcoin"
   */
  asset_name?: string;
  /**
   * Asset symbol
   * @example "BTC"
   */
  asset_symbol?: string;
  /**
   * Asset logo URL
   * @example "https://example.com/btc.png"
   */
  asset_logo?: string;
  /**
   * Created timestamp
   * @format int64
   * @example 1640995200000
   */
  created_time?: number;
  /**
   * Status (1:Normal 0:Hidden -1:Deleted)
   * @example 1
   */
  status?: number;
  /**
   * Modified timestamp
   * @format int64
   * @example 1640995200000
   */
  modified_time?: number;
}

/** Pagination information */
export interface PortfolioAssetPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next  token */
  next_token?: string;
  rows?: PortfolioAsset[];
}

export type PortfolioAssetPaginationResponse = BaseResponse & {
  /** Pagination information */
  data?: PortfolioAssetPagination;
};

/** Portfolio item structure */
export interface PortfolioItem {
  /**
   * Portfolio ID
   * @example "12345"
   */
  id?: string;
  /**
   * Portfolio name
   * @example "My Investment Portfolio"
   */
  name?: string;
  /**
   * Asset count
   * @format int32
   */
  asset_count?: number;
  /** status */
  status?: "NORMAL" | "HIDDEN";
  /**
   * Created time
   * @format int64
   * @example 1640995200000
   */
  created?: number;
}

/** Portfolio pagination information */
export interface PortfolioPagination {
  /**
   * Request data count
   * @format int32
   * @min 1
   * @max 100
   */
  limit?: number;
  /**
   * Total count
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: PortfolioItem[];
}

export type PortfolioPaginationResponse = BaseResponse & {
  /** Portfolio pagination information */
  data?: PortfolioPagination;
};

export type PortfolioResponse = BaseResponse & {
  /** Portfolio item structure */
  data?: PortfolioItem;
};

/** price change percentage for a specific time period */
export interface PriceChangePercentage {
  /** time period, eg. 1h, 24h, 7d, 14d, 30d, 200d, 1y */
  time_period?: string;
  /** coin price change percentage in currency */
  percentage?: number;
}

export interface PricePoint {
  /**
   * The timestamp of the sparkline
   * @format int64
   */
  timestamp?: number;
  price?: number;
}

/** multi-language content structure */
export interface QuestionMultiLanguageContent {
  /**
   * language code
   * @example "en-US"
   */
  language: string;
  /**
   * content title
   * @example "Why is {token} price moving today?"
   */
  title: string;
  /**
   * content description
   * @example "Discover what's making token prices change"
   */
  description?: string;
  /**
   * display title for UI
   * @example "Why It Moves"
   */
  display_title?: string;
  /**
   * content answer
   * @example "{name} ({symbol}) current price is {current_price}, {percentageSymbol} {price_change_percentage_24h}% today."
   */
  answer: string;
}

/** recommend query request parameters */
export interface ScopedRecommendRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @max 20
   * @default 10
   */
  limit?: number;
  /**
   * related keyword or context
   * @example "bitcoin"
   */
  related?: string;
  /** related_condition[c1]=v1&related_condition[c2]=v2&related_condition[c2]=v3 */
  related_condition?: Record<string, any>;
}

export type RecommendPaginationResponse = (BaseResponse & object) & {
  data?: RecommendScopePagination;
};

export interface RecommendScopePagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: RecommendDTO[];
}

export interface StochasticEnrichOption {
  /**
   * If you need to return the Stochastic information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 14. The number of data points used to calculate Stochastic.
   * @format int32
   * @default 14
   */
  period?: number;
  /**
   * Optional. Default is 3. The smoothing period for %K.
   * @format int32
   * @default 3
   */
  smooth_k?: number;
  /**
   * Optional. Default is 3. The smoothing period for %D.
   * @format int32
   * @default 3
   */
  smooth_d?: number;
}

export interface TrendAnalysisEnrichOption {
  /**
   * If you need to return the Trend Analysis information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 30. The number of data points used to calculate Trend Analysis.
   * @format int32
   * @default 30
   */
  time_period?: number;
}

/** Stochastic Oscillator */
export interface Stochastic {
  /**
   * The number of data points used to calculate Stochastic
   * @format int32
   */
  time_period?: number;
  /** Stochastic %K values */
  k?: number[];
  /** Stochastic %D values */
  d?: number[];
}

/** Relative Strength Index */
export interface RSI {
  /** Relative Strength Index */
  values?: number[];
  /** @format int32 */
  time_period?: number;
}

/** 360 rating score */
export interface Rating {
  /** 360 rating level map */
  level?: Record<string, string>;
  /** 360 rating score map */
  score?: Record<string, number>;
  /** pillar scores grouped by pillar name */
  pillar_scores?: Record<
    string,
    {
      /** pillar score */
      score?: number;
      /** pillar score description */
      description?: string;
    }
  >;
  /** ranking data grouped by theme */
  pillar_rankings?: {
    /** theme id */
    theme_id?: string;
    /**
     * asset ranking in the theme
     * @format int64
     */
    ranking?: number;
    /**
     * total number of assets participating in the theme ranking
     * @format int64
     */
    ranking_count?: number;
    /** pillar rankings grouped by pillar name, key is pillar dimension, value is ranking */
    pillars?: Record<string, number>;
  }[];
  /** 360 report title */
  title?: string;
  /** 360 report summary */
  summary?: string;
  /** 360 report tldr */
  tldr?: string;
  /** 360 report table of contents */
  toc?: string[];
  /**
   * 360 report time
   * @format int64
   */
  report_time?: number;
}

/** recommend item structure */
export interface RecommendDTO {
  /**
   * item type
   * @example "QUESTION"
   */
  category?: string;
  /** data id */
  id?: string;
  /** multi-language content list */
  multi_language_contents?: QuestionMultiLanguageContent[];
}

export type RecommendResponse = BaseResponse & {
  /**
   * recommend query response data
   * @example {"TOKEN_FAQ":[{"type":"QUESTION","multi_language_contents":[{"language":"en-US","title":"What is the current price of {name} ({symbol})?","answer":"{name} ({symbol}) current price is {current_price}, {percentageSymbol} {price_change_percentage_24h}% today."}]}],"TOKEN":[{"type":"QUESTION","name":"bitcoin","icon":"","symbol":"BTC"}]}
   */
  data?: Record<string, RecommendDTO[]>;
};

export interface RecommendationTrend {
  recommendation?: "STRONG_BUY" | "BUY" | "NEUTRAL" | "SELL" | "STRONG_SELL";
  trend?: {
    /** The number of buy recommendations */
    buy?: number;
    /** The number of sell recommendations */
    sell?: number;
    /** The number of hold recommendations */
    hold?: number;
    /** The number of strong buy recommendations */
    strong_buy?: number;
    /** The number of strong sell recommendations */
    strong_sell?: number;
    /**
     * The period of the recommendation trend in milliseconds
     * @format int64
     */
    period?: number;
  }[];
}

/** Remove from Portfolio Asset request parameters */
export interface RemovePortfolioAssetRequest {
  /**
   * Asset ID
   * @example "bitcoin"
   */
  asset_id: string;
  /** Asset type filter */
  asset_type?: "TOKEN" | "STOCK";
  /**
   * Portfolio IDs
   * @maxItems 30
   */
  portfolio_ids?: string[];
}

export interface SearchOpenData {
  /** open data type */
  type?: OpenDataTypeEnum;
  /** open data entity id */
  id: string;
  /** opendata entity name */
  name?: string;
  /** opendata entity detailed description */
  desc?: string;
  addresses?: OnChainNetworkAddress[];
  /** URL of opendata entity */
  image?: string;
  /** opendata token entity symbol */
  symbol?: string;
  themes?: string[];
  /**
   * issue date
   * @format int64
   */
  issue_date?: number;
  /** source link */
  source_link?: string;
  /** stock market */
  market?: string;
  /** stock short name */
  short_name?: string;
  /** sub types */
  sub_types?: OpenDataTypeEnum[];
}

export interface SearchOpenDataGroup {
  /** open data type */
  type?: OpenDataTypeEnum;
  rows?: SearchOpenData[];
}

export type SearchOpenDataGroupResponse = BaseResponse & {
  data?: SearchOpenDataGroup[];
};

export interface SearchOpenDataPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int64
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: SearchOpenData[];
}

export type SearchOpenDataPaginationResponse = BaseResponse & {
  data?: SearchOpenDataPagination;
};

export interface Sentiment {
  /** sentiment type */
  sentiment?: "BULLISH" | "BEARISH" | "NEUTRAL";
  /**
   * sentiment people count
   * @format int64
   */
  count?: number;
  authors?: People[];
}

/** people social metrics */
export interface SocialMetrics {
  /**
   * follower count
   * @format int64
   */
  followers?: number;
  /**
   * following count
   * @format int64
   */
  following?: number;
  /**
   * smart account follower count
   * @format int64
   */
  smart_followers?: number;
  /**
   * smart account following count
   * @format int64
   */
  smart_following?: number;
  /**
   * follower count ranking
   * @format int64
   */
  followers_ranking?: number;
  /**
   * The total number of people who participated in the follower count ranking
   * @format int64
   */
  followers_ranking_count?: number;
  /**
   * latest 7 days post view count
   * @format int64
   */
  view_count?: number;
  /**
   * latest 7 days post view count ranking
   * @format int64
   */
  view_count_ranking?: number;
  /**
   * The total number of participants in the ranking of post exposures in the past 7 days.
   * @format int64
   */
  view_count_ranking_count?: number;
  /**
   * last update time
   * @format int64
   */
  last_update_time?: number;
  /**
   * impression count
   * @format int64
   */
  impression?: number;
  /**
   * impression count ranking
   * @format int64
   */
  impression_ranking?: number;
  /**
   * impression count total
   * @format int64
   */
  impressions_total?: number;
  /**
   * total follower count
   * @format int64
   */
  followers_total?: number;
  /**
   * total smart account follower count
   * @format int64
   */
  smart_followers_total?: number;
  /**
   * smart account follower count ranking
   * @format int64
   */
  smart_follower_ranking?: number;
}

export interface Stock {
  /** The id of the stock */
  id?: string;
  /** The symbol of the stock */
  symbol?: string;
  /** The name of the stock */
  name?: string;
  /** The company_name of the stock */
  company_name?: string;
  /** The short name of the stock */
  short_name?: string;
  /** The log of the company_name */
  logo?: string;
  /** The description of the stock */
  description?: string;
  /** The multi language description of the stock */
  multi_language_desc?: object;
  /** The type of the stock */
  type?: string;
  themes?: string[];
  theme_ids?: string[];
  tags?: string[];
  /** The industry of the stock */
  industry?: string;
  /** The sector of the stock */
  sector?: string;
  /**
   * ipo time in ms
   * @format int64
   */
  ipo_time?: number;
  sparkline?: PricePoint[];
  trading_data?: TradingData;
  /** 360 rating score */
  latest_rating?: Rating;
  /** Target price prediction. */
  target_price?: TargetPrice;
  ohlcv?: OHLC[];
  recommendation_trend?: RecommendationTrend;
  /** The executives of the company */
  executives?: People[];
  /** Historical earnings data */
  earnings?: EarningData;
  /** Revenue estimate data */
  revenue_estimates?: RevenueEstimate[];
  /** Earning quality score data */
  earning_scores?: EarningScore[];
  /** Historical dividends data */
  dividends?: DividendData;
  /** Financial statements data */
  financials?: FinancialData;
  /** Revenue breakdown data by geography and product */
  revenue_breakdown?: RevenueBreakdown;
  /** Stochastic Oscillator */
  stochastic?: Stochastic;
  /** Trend Analysis */
  trend_analysis?: TrendAnalysis;
  /** stock market */
  market?: StockMarketEnum;
  /**
   * currency
   * @default "USD"
   */
  currency?: "USD" | "HKD" | "CNY";
}

export interface FinancialData {
  /** Financial statements data list */
  items?: Financial[];
}

export interface DividendData {
  /**
   * dividend yield ttm
   * @example 0.12
   */
  dividend_yield_ttm?: number;
  /**
   * dividend per share annual
   * @format bi
   * @example 0.12
   */
  dividend_per_share_annual?: number;
  /**
   * payout ratio ttm
   * @example 0.12
   */
  payout_ratio_ttm?: number;
  /** Historical dividends data list */
  items?: Dividend[];
}

export interface EarningData {
  /** Historical earnings data list */
  items?: EarningsCalendar[];
}

export type RevenueBreakdown = Record<
  string,
  {
    /**
     * Category label (e.g., region name, product name)
     * @example "Americas"
     */
    label?: string;
    /** Data points */
    data?: {
      /**
       * Period
       * @example "2013-09-28"
       */
      period?: string;
      /**
       * Revenue value
       * @format int64
       * @example 77093000000
       */
      value?: number;
    }[];
  }[]
>;

export interface EarningScore {
  /**
   * Cash generation and capital allocation efficiency score
   * @example 49.336037
   */
  cash_generation_capital_allocation?: number;
  /**
   * Growth score
   * @example 87.94706
   */
  growth?: number;
  /**
   * Overall assessment score
   * @example "A-"
   */
  letter_score?: string;
  /**
   * Leverage score
   * @example 53.926353
   */
  leverage?: number;
  /**
   * Financial period end date
   * @example "2025-06-28"
   */
  period?: string;
  /**
   * Profitability score
   * @example 75.02416
   */
  profitability?: number;
  /**
   * Final score
   * @example 66.5584
   */
  score?: number;
}

export interface Dividend {
  /**
   * Dividend amount
   * @example 0.11
   */
  amount?: number;
  /**
   * Adjusted dividend amount
   * @example 0.001
   */
  adjusted_amount?: number;
  /**
   * Ex-dividend date
   * @example "2025-08-11"
   */
  ex_dividend_date?: string;
  /**
   * Payment date
   * @example "2025-08-14"
   */
  pay_date?: string;
  /**
   * Record date
   * @example "2025-08-11"
   */
  record_date?: string;
  /**
   * pay frequency 0 = Annually 1 = Monthly 2 = Quarterly 3 = Semi-annually 4 = Other/Unknown 5 = Bimonthly 6 = Trimesterly 7 = Weekly
   * @example "2"
   */
  pay_freq?: string;
  /**
   * Currency (from StockDTO.currency)
   * @example "USD"
   */
  currency?: string;
}

export interface Financial {
  /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
  freq?: FinancialFrequency;
  /**
   * Financial period end date
   * @example "2024-09-28"
   */
  period?: string;
  /**
   * Financial year
   * @format int32
   * @example 2024
   */
  year?: number;
  /**
   * Financial statement type
   * @example "ic"
   */
  statement_type?: "ic" | "bs" | "cf";
  /**
   * Cost of goods sold
   * @format int64
   * @example 210352
   */
  cost_of_goods_sold?: number;
  /**
   * Diluted average shares outstanding
   * @example 15408.095
   */
  diluted_average_shares_outstanding?: number;
  /**
   * Diluted earnings per share
   * @example 6.08
   */
  diluted_eps?: number;
  /**
   * Earnings before interest and taxes
   * @format int64
   * @example 123216
   */
  ebit?: number;
  /**
   * Gross income
   * @format int64
   * @example 180683
   */
  gross_income?: number;
  /**
   * Net income
   * @format int64
   * @example 93736
   */
  net_income?: number;
  /**
   * Net income after taxes
   * @format int64
   * @example 103982
   */
  net_income_after_taxes?: number;
  /**
   * Pretax income
   * @format int64
   * @example 123485
   */
  pretax_income?: number;
  /**
   * Provision for income taxes
   * @format int64
   * @example 19503
   */
  provision_for_income_taxes?: number;
  /**
   * Research and development
   * @format int64
   * @example 31370
   */
  research_development?: number;
  /**
   * Revenue
   * @format int64
   * @example 391035
   */
  revenue?: number;
  /**
   * Selling, general and administrative expenses
   * @format int64
   * @example 26097
   */
  sga_expense?: number;
  /**
   * Total operating expenses
   * @format int64
   * @example 57467
   */
  total_operating_expense?: number;
  /**
   * Total other income expense net
   * @format int64
   * @example 269
   */
  total_other_income_expense_net?: number;
  /**
   * Accounts payable
   * @format int64
   * @example 68960
   */
  accounts_payable?: number;
  /**
   * Accounts receivables
   * @format int64
   * @example 33410
   */
  accounts_receivables?: number;
  /**
   * Accrued liability
   * @format int64
   * @example 1488
   */
  accrued_liability?: number;
  /**
   * Accumulated depreciation
   * @format int64
   * @example -73448
   */
  accumulated_depreciation?: number;
  /**
   * Additional paid-in capital
   * @example 83275.849
   */
  additional_paid_in_capital?: number;
  /**
   * Cash
   * @format int64
   * @example 27199
   */
  cash?: number;
  /**
   * Cash equivalents
   * @format int64
   * @example 2744
   */
  cash_equivalents?: number;
  /**
   * Cash and short-term investments
   * @format int64
   * @example 65171
   */
  cash_short_term_investments?: number;
  /**
   * Common stock
   * @example 0.151
   */
  common_stock?: number;
  /**
   * Current assets
   * @format int64
   * @example 152987
   */
  current_assets?: number;
  /**
   * Current liabilities
   * @format int64
   * @example 176392
   */
  current_liabilities?: number;
  /**
   * Current portion of long-term debt
   * @format int64
   * @example 11056
   */
  current_portion_long_term_debt?: number;
  /**
   * Inventory
   * @format int64
   * @example 7286
   */
  inventory?: number;
  /**
   * Liabilities and shareholders equity
   * @format int64
   * @example 364980
   */
  liabilities_shareholders_equity?: number;
  /**
   * Long-term debt
   * @format int64
   * @example 86502
   */
  long_term_debt?: number;
  /**
   * Long-term investments
   * @format int64
   * @example 91479
   */
  long_term_investments?: number;
  /**
   * Net debt
   * @format int64
   * @example 42354
   */
  net_debt?: number;
  /**
   * Other current assets
   * @format int64
   * @example 14287
   */
  other_current_assets?: number;
  /**
   * Other current liabilities
   * @format int64
   * @example 84921
   */
  other_current_liabilities?: number;
  /**
   * Other equity
   * @format int64
   * @example -7172
   */
  other_equity?: number;
  /**
   * Other liabilities
   * @format int64
   * @example 45136
   */
  other_liabilities?: number;
  /**
   * Other long-term assets
   * @format int64
   * @example 64600
   */
  other_long_term_assets?: number;
  /**
   * Other receivables
   * @format int64
   * @example 32833
   */
  other_receivables?: number;
  /**
   * Property, plant and equipment
   * @format int64
   * @example 55914
   */
  property_plant_equipment?: number;
  /**
   * Retained earnings
   * @format int64
   * @example -19154
   */
  retained_earnings?: number;
  /**
   * Shares outstanding
   * @example 15116.786
   */
  shares_outstanding?: number;
  /**
   * Short-term debt
   * @format int64
   * @example 9967
   */
  short_term_debt?: number;
  /**
   * Short-term investments
   * @format int64
   * @example 35228
   */
  short_term_investments?: number;
  /**
   * Tangible book value per share
   * @example 3.7673
   */
  tangible_book_value_per_share?: number;
  /**
   * Total assets
   * @format int64
   * @example 364980
   */
  total_assets?: number;
  /**
   * Total debt
   * @format int64
   * @example 107525
   */
  total_debt?: number;
  /**
   * Total equity
   * @format int64
   * @example 56950
   */
  total_equity?: number;
  /**
   * Total liabilities
   * @format int64
   * @example 308030
   */
  total_liabilities?: number;
  /**
   * Total receivables
   * @format int64
   * @example 66243
   */
  total_receivables?: number;
  /**
   * Capital expenditures
   * @format int64
   * @example -9447
   */
  capex?: number;
  /**
   * Cash dividends paid
   * @format int64
   * @example -15234
   */
  cash_dividends_paid?: number;
  /**
   * Cash taxes paid
   * @format int64
   * @example 26102
   */
  cash_taxes_paid?: number;
  /**
   * Change in cash
   * @format int64
   * @example -794
   */
  change_in_cash?: number;
  /**
   * Changes in working capital
   * @format int64
   * @example 3651
   */
  changes_in_working_capital?: number;
  /**
   * Depreciation and amortization
   * @format int64
   * @example 11445
   */
  depreciation_amortization?: number;
  /**
   * Free cash flow
   * @format int64
   * @example 108807
   */
  fcf?: number;
  /**
   * Issuance/reduction of capital stock
   * @format int64
   * @example -94949
   */
  issuance_reduction_capital_stock?: number;
  /**
   * Issuance/reduction of debt net
   * @format int64
   * @example -5998
   */
  issuance_reduction_debt_net?: number;
  /**
   * Net cash from financing activities
   * @format int64
   * @example -121983
   */
  net_cash_financing_activities?: number;
  /**
   * Net income starting line
   * @format int64
   * @example 93736
   */
  net_income_starting_line?: number;
  /**
   * Net cash from investing activities
   * @format int64
   * @example 2935
   */
  net_investing_cash_flow?: number;
  /**
   * Net cash from operating activities
   * @format int64
   * @example 118254
   */
  net_operating_cash_flow?: number;
  /**
   * Other financing items
   * @format int64
   * @example -5802
   */
  other_funds_financing_items?: number;
  /**
   * Other non-cash items
   * @format int64
   * @example 9422
   */
  other_funds_non_cash_items?: number;
  /**
   * Other investing cash flow items total
   * @format int64
   * @example 12382
   */
  other_investing_cash_flow_items_total?: number;
  /**
   * Stock-based compensation
   * @format int64
   * @example 11688
   */
  stock_based_compensation?: number;
  /** @example 0.15 */
  revenue_growth_yoy?: number;
  /**
   * Net income growth (净利润增长率)
   * @example 0.12
   */
  net_income_growth?: number;
  /**
   * Shares change year over year (股份同比增长率)
   * @example 0.05
   */
  shares_change_yoy?: number;
  /**
   * EPS growth (每股收益增长率)
   * @example 0.1
   */
  eps_growth?: number;
  /**
   * Cash growth (现金增长率)
   * @example 0.08
   */
  cash_growth?: number;
  /**
   * Net cash growth (净现金增长率)
   * @example 0.07
   */
  net_cash_growth?: number;
  /**
   * Operating cash flow growth (经营活动现金流增长率)
   * @example 0.11
   */
  operating_cash_flow_growth?: number;
  /**
   * Free cash flow growth (自由现金流增长率)
   * @example 0.09
   */
  fcf_growth?: number;
}

/** Market schedule response */
export type MarketScheduleResponse = BaseResponse & {
  data?: {
    /** stock market */
    market?: StockMarketEnum;
    /** Time zone identifier (e.g., Asia/Hong_Kong) */
    timeZone?: string;
    /** stock market state */
    current_state?: StockMarketStateEnum;
    schedule?: {
      previous?: {
        phases?: Record<
          string,
          {
            /**
             * Start timestamp in milliseconds
             * @format int64
             */
            start?: number;
            /**
             * End timestamp in milliseconds
             * @format int64
             */
            end?: number;
          }[]
        >;
      };
      current?: {
        phases?: Record<
          string,
          {
            /**
             * Start timestamp in milliseconds
             * @format int64
             */
            start?: number;
            /**
             * End timestamp in milliseconds
             * @format int64
             */
            end?: number;
          }[]
        >;
      };
      next?: {
        phases?: Record<
          string,
          {
            /**
             * Start timestamp in milliseconds
             * @format int64
             */
            start?: number;
            /**
             * End timestamp in milliseconds
             * @format int64
             */
            end?: number;
          }[]
        >;
      };
    };
  };
};

export interface RevenueEstimate {
  /**
   * Number of analysts
   * @format int32
   * @example 3
   */
  number_analysts?: number;
  /**
   * Estimate period
   * @example "2031-09-30"
   */
  period?: string;
  /**
   * Quarter (null for annual data)
   * @format int32
   * @example null
   */
  quarter?: number | null;
  /**
   * Estimated average revenue
   * @format int64
   * @example 608346000000
   */
  revenue_avg?: number;
  /**
   * Estimated high revenue
   * @format int64
   * @example 626239000000
   */
  revenue_high?: number;
  /**
   * Estimated low revenue
   * @format int64
   * @example 584490000000
   */
  revenue_low?: number;
  /**
   * Estimate year
   * @format int32
   * @example 2031
   */
  year?: number;
}

export interface StockPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: Stock[];
}

export type StockPaginationResponse = BaseResponse & {
  data?: StockPagination;
};

/** Target price prediction. */
export interface TargetPrice {
  /**
   * The time when the prediction was made.
   * @format int64
   * @example "2025-08-03T00:00:00Z"
   */
  last_updated?: number;
  /**
   * The predicted highest price.
   * @example 391.5135
   */
  high?: number;
  /**
   * The predicted lowest price.
   * @example 101
   */
  low?: number;
  /**
   * The predicted average price.
   * @example 188.644206
   */
  mean?: number;
  /** The number of analysts providing price forecasts */
  analyst_count?: number;
  /** The prediction period. */
  period?: "SHORT" | "LONG" | "MEDIUM";
}

/** theme data */
export interface ThemeItem {
  /** theme id */
  id?: string;
  /** theme name */
  theme?: string;
  /** theme slug */
  slug?: string;
  /** theme types */
  scopes?: string[];
  /** theme images */
  images?: ImageField[];
  /** theme description */
  desc?: string;
  /** market */
  market?: string;
  /** open data type */
  type?: OpenDataTypeEnum;
  /** theme market data */
  market_data?: {
    /**
     * market data timestamp
     * @format int64
     */
    timestamp?: number;
    /** total market capitalization */
    market_cap?: number;
    /** price change percentage for a specific time period */
    price_change_percentage?: PriceChangePercentage;
    /** theme beta value */
    beta?: number;
  };
  /** top symbol list for this theme, concatenated list of gainers followed by losers (present when top movers enrich enabled) */
  symbols?: ThemeSymbol[];
  /** content list for this theme */
  contents?: Content[];
  /** theme summary,JSON array, have language and text */
  summaries?: string;
  /** theme summary */
  summary?: string;
}

export interface ThemeItemPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int64
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: ThemeItem[];
}

export type ThemeItemPaginationResponse = BaseResponse & {
  data?: ThemeItemPagination;
};

export interface ListThemeItemsRequest {
  /** theme data type */
  type: OpenDataTypeEnum;
  /**
   * theme names array,wait delete
   * @maxItems 20
   * @minItems 1
   */
  names: string[];
  /**
   * query type, currently only support TRENDING
   * @default "TRENDING"
   */
  query_type?: "TRENDING" | "MARKET_DATA";
  /**
   * limit number of symbols per theme
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
}

/** theme content response */
export interface ThemeSymbolItemsResponse {
  /** request success status */
  success?: boolean;
  /** response data */
  data?: {
    /** theme content rows */
    rows?: ThemeSymbolItem[];
  };
  error?: Error;
}

/** theme item */
export interface ThemeSymbolItem {
  /** theme name */
  theme?: string;
  /** theme data type */
  type?: OpenDataTypeEnum;
  /** top symbol list for this theme */
  items?: ThemeSymbol[];
}

/** symbol information */
export interface ThemeSymbol {
  /** symbol name */
  symbol?: string;
  /** symbol full name */
  name?: string;
  /** The current price of the stock,crypto */
  current_price?: number;
  /** coin price change percentage 7d in currency */
  price_change_percentage?: PriceChangePercentage[];
  /** symbol id */
  id?: string;
  /** The previous close price of the stock */
  previous_close?: number;
  /** symbol icon */
  logo?: string;
  /** 360 rating score */
  latest_rating?: Rating;
  /** stock symbol company name */
  company_name?: string;
  /** hk stock symbol short name */
  short_name?: string;
}

export interface GetTokenRankingRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @min 1
   * @max 50
   * @default 5
   */
  limit?: number;
  /** token's themes */
  themes?: string[];
  /** theme ids */
  themeIds?: string[];
  type?: "BLUE_CHIP" | "REPORT_360";
  sort?: TokenSort;
  enrich?: TokenEnrichOption;
  /** language */
  language?: string;
}

/** theme enrichment options */
export interface ThemeEnrichOption {
  /**
   * enable enrichment
   * @default false
   */
  enable?: boolean;
  /** market data enrichment options */
  with_market?: {
    /**
     * enable market data
     * @default false
     */
    enable?: boolean;
    /**
     * content language
     * @default "en-US"
     */
    language?: string;
  };
  /** symbol enrichment options */
  with_symbol?: {
    /**
     * enable symbol data
     * @default false
     */
    enable?: boolean;
    /**
     * symbol limit
     * @format int32
     * @min 0
     * @default 0
     */
    limit?: number;
    sort?: ThemeSortOption;
  };
  /** content enrichment options */
  with_content?: {
    /**
     * enable content data
     * @default false
     */
    enable?: boolean;
    /**
     * content limit
     * @format int32
     * @min 0
     * @default 0
     */
    limit?: number;
    /**
     * content language
     * @default "en-US"
     */
    language?: string;
  };
}

export interface ThemeSortOption {
  /** @default "PRICE_CHANGE_24H" */
  field?: "MANUAL" | "MARKET_CAP" | "PRICE_CHANGE_24H" | "TOP";
  order?: "ASC" | "DESC";
}

/** Average Directional Index */
export interface Ticker {
  /** target symbol */
  target?: string;
  /** market name */
  market_name?: string;
}

/** token info */
export interface Token {
  /** token id */
  id?: string;
  /** token symbol */
  symbol?: string;
  /** token name */
  name?: string;
  /** token alias names */
  aliases?: string[];
  /** token tags */
  tags?: string[];
  /** token web slug */
  web_slug?: string;
  /** token logo image */
  logo?: string;
  /** token detailed desc */
  desc?: string;
  /** multi language detailed desc */
  multi_language_desc?: object;
  pools?: Pool[];
  addresses?: OnChainNetworkAddress[];
  /** token market data */
  market_data?: MarketData;
  ohlc?: OHLC[];
  /** Total supply */
  total_supply?: number;
  /** Circulating supply */
  circulating_supply?: number;
  /** Maximum supply */
  max_supply?: number;
  ma?: MA[];
  /** Detrended Price Oscillator */
  dpo?: DPO;
  /** Average Directional Index */
  adx?: ADX;
  ema?: EMA[];
  /** Commodity Channel Index */
  cci?: CCI;
  rsi?: RSI[];
  /** Bollinger Bands */
  bbands?: BBands;
  /** Moving Average Convergence/Divergence */
  macd?: MACD;
  /** Token holder information */
  holder?: Holder;
  sentiment?: Sentiment[];
  flows?: ExchangeFlow[];
  exchanges?: People[];
  team_members?: People[];
  investors?: People[];
  /**
   * Last updated timestamp
   * @format int64
   */
  last_updated?: number;
  /** people social media info */
  social_media?: OpenSocialMedia;
  /**
   * issue date of coin
   * @format int64
   */
  issue_date?: number;
  tickers?: Ticker[];
  data_sources?: OpenDataSource[];
  /** 360 rating score */
  latest_rating?: Rating;
  listings?: Listing[];
  sparkline?: PricePoint[];
  /** Target price prediction. */
  target_price?: TargetPrice;
  /**
   * token funding rate
   * @example 0.0112
   */
  funding_rate?: number;
  /** token themes */
  themes?: string[];
  theme_ids?: string[];
  /** Stochastic Oscillator */
  stochastic?: Stochastic;
  /** Trend Analysis */
  trend_analysis?: TrendAnalysis;
}

export interface TokenEnrichOption {
  /**
   * If you need to return the token relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * if need to return some social metrics, set this to true
   * @default false
   */
  with_social_metrics?: boolean;
  /**
   * If you need to include the liquidity pools where this token can be traded, set this to true.
   * @default false
   */
  with_pool?: boolean;
  /**
   * If you need to return the network relative information, set this to true
   * @default false
   */
  with_network?: boolean;
  /** If you need to return the asset must include types, set this to specific types. */
  include_types?: string[];
  with_adx?: ADXEnrichOption;
  with_cci?: CCIEnrichOption;
  with_dpo?: DPOEnrichOption;
  with_ema?: EMAEnrichOption;
  with_rsi?: RSIEnrichOption;
  with_ma?: MAEnrichOption;
  with_macd?: MACDEnrichOption;
  with_bbands?: BBandsEnrichOption;
  with_market?: MarketDataEnrichOption;
  with_ohlc?: OHLCEnrichOption;
  with_holder?: HolderEnrichOption;
  with_sentiment?: SentimentEnrichOption;
  with_flow?: FlowEnrichOption;
  /**
   * If you need to return the team members information, set this to true
   * @default false
   */
  with_team?: boolean;
  /**
   * If you need to return the investors information, set this to true
   * @default false
   */
  with_investor?: boolean;
  /**
   * If you need to return supporting exchanges list, set this to true
   * @default false
   */
  with_exchange?: boolean;
  /**
   * If you need to return the ticker information, set this to true
   * @default false
   */
  with_ticker?: boolean;
  /**
   * If you need to return just the 360 report list, set this to true
   * @default false
   */
  with_rating?: boolean;
  with_sparkline?: SparklineEnrichOption;
  /**
   * If you need to return the funding rate, set this to true
   * @default false
   */
  with_funding_rate?: boolean;
  with_stochastic?: StochasticEnrichOption;
  with_trend_analysis?: TrendAnalysisEnrichOption;
}

export interface TokenPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  rows?: Token[];
}

export type TokenPaginationResponse = BaseResponse & {
  data?: TokenPagination;
};

export interface TradingData {
  /** The current price of the stock */
  current_price?: number;
  /** The previous close price of the stock */
  previous_close?: number;
  /** The highest price during trading session - current day after market opens, previous trading day before market opens */
  high?: number;
  /** The lowest price during trading session - current day after market opens, previous trading day before market opens */
  low?: number;
  /** The opening price of trading session - current day after market opens, previous trading day before market opens */
  open?: number;
  /** The closing price of trading session - current day after market opens, previous trading day before market opens */
  close?: number;
  /** The closing price from 2 trading days ago */
  close_2_days_ago?: number;
  /** The closing price from 5 trading days ago */
  close_5_days_ago?: number;
  /** The closing price from 10 trading days ago */
  close_10_days_ago?: number;
  /** The lowest price in the last 52 weeks */
  low_52_w?: number;
  /** The highest price in the last 52 weeks */
  high_52_w?: number;
  /** The opening price of the stock in the current year */
  open_current_year?: number;
  /** Earnings per share trailing twelve months */
  eps_ttm?: number;
  /**
   * Trading volume for the day
   * @format int64
   */
  volume?: number;
  /**
   * Total number of shares outstanding
   * @format int64
   */
  shares_outstanding?: number;
  /**
   * The start time of pre-market trading session
   * @format int64
   */
  pre_market_open_time?: number;
  /**
   * The start time of regular trading session
   * @format int64
   */
  regular_market_open_time?: number;
  /**
   * The end time of regular trading session
   * @format int64
   */
  regular_market_close_time?: number;
  /**
   * The end time of post-market trading session
   * @format int64
   */
  post_market_close_time?: number;
  /**
   * The start time of regular trading session on previous trading day
   * @format int64
   */
  previous_regular_market_open_time?: number;
  /**
   * The end time of regular trading session on previous trading day
   * @format int64
   */
  previous_regular_market_close_time?: number;
  /**
   * The end time of post-market trading session on previous trading day
   * @format int64
   */
  previous_post_market_close_time?: number;
  /**
   * The start time of pre-market trading session on next trading day
   * @format int64
   */
  next_pre_market_open_time?: number;
  /** Annual dividend per share */
  dividend_per_share_annual?: number;
  /** Average volume over the last 3 months */
  average_volume_3_m?: number;
  /** Price-earnings ratio annual */
  pe_annual?: number;
  /** Fibonacci low */
  fibonacci_low?: number;
  /** Fibonacci high */
  fibonacci_high?: number;
  /** Beta value */
  beta?: number;
}

/** TVL info */
export interface Tvl {
  /**
   * timestamp of TVL
   * @format int64
   */
  date?: number;
  /**
   * value of TVL
   * @example "1,8453"
   */
  val?: number;
}

/** Update portfolio request parameters */
export interface UpdatePortfolioRequest {
  /** @example "12345" */
  id: string;
  /**
   * Portfolio name
   * @example "Updated Portfolio Name"
   */
  name: string;
}

export interface Forex {
  /** forex id */
  id?: string;
  /** base currency symbol */
  base?: string;
  /** quote currency symbol */
  quote?: string;
  market_data?: {
    /** current price */
    current_price?: number;
  };
}

export interface ForexPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** @format int32 */
  offset?: number;
  rows?: Forex[];
}

export type ForexPaginationResponse = BaseResponse & {
  data?: ForexPagination;
};

/** get theme request */
export interface GetThemeRequest {
  /**
   * page offset
   * @format int32
   * @min 0
   * @default 0
   */
  offset?: number;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   * @default 10
   */
  limit?: number;
  /** theme data type */
  type: OpenDataTypeEnum;
  /** theme ids */
  ids?: string[];
  /** theme slugs (name_en) */
  slugs?: string[];
  /** theme types (hotSearch, heatmap, recommend) */
  scopes?: string[];
  /** market (US, HK) */
  market?: string;
  /**
   * theme names array
   * @maxItems 20
   * @minItems 0
   */
  names?: string[];
  /** theme enrichment options */
  enrich?: ThemeEnrichOption;
  /** @default "en-US" */
  language?: string;
}

/** get ranking theme request */
export interface GetRankingThemeRequest {
  /**
   * page offset
   * @format int32
   * @min 0
   * @default 0
   */
  offset?: number;
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 50
   * @default 10
   */
  limit?: number;
  /** theme data type */
  type: OpenDataTypeEnum;
  /** theme ids */
  ids?: string[];
  /** theme slugs (name_en) */
  slugs?: string[];
  /** theme types (hotSearch, heatmap, recommend) */
  scopes?: string[];
  /** market (US, HK) */
  market?: string;
  /** @default "en-US" */
  language?: string;
  /** theme enrichment options */
  enrich?: ThemeEnrichOption;
  sort?: ThemeSortOption;
}

export interface SearchOpenDataRequest {
  types?: OpenDataTypeEnum[];
  /** query keyword string */
  keyword: string;
  /**
   * query operator
   * @default "MATCH"
   */
  operator?: "MATCH" | "PREFIX" | "EXACT";
  query?: OpenDataQuery;
  /**
   * query limit
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** @default "en-US" */
  language?: string;
  market?: string;
  sub_type?: string;
}

export interface OpenDataQuery {
  conditions?: OpenDataQueryCondition[];
  /** @default "AND" */
  condition_type?: "AND" | "OR";
}

/** image field */
export interface ImageField {
  /** type */
  type?: string;
  /** url */
  url?: string;
}

export interface GetRankingContentRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   * @default 10
   */
  limit?: number;
  /** category */
  category?: ContentCategoryEnum;
  /** content type */
  type?: ContentTypeEnum;
  /** author' handles, comma-separated if querying more than 1 people. */
  authors?: string[];
  /** The handles mentioned in the post */
  mentions?: string[];
  /** The symbols mentioned in the post */
  symbols?: string[];
  /** content theme，'Other' is a special theme only return contents without themes */
  themes?: string[];
  /** theme ids */
  themeIds?: string[];
  /** HIGH/LOW, used to distinguish pinned Article content */
  level?: string;
  /** themes to exclude */
  exclude_themes?: string[];
  enrich?: ContentEnrichOption;
  sort?: ContentSort;
  /**
   * On or after a specified unix timestamp in milliseconds.
   * @format int64
   */
  start_time?: number;
  /**
   * Before a specified unix timestamp in milliseconds.
   * @format int64
   */
  end_time?: number;
  /** @default "en-US" */
  language?: string;
  /** US,HK */
  market?: string;
}

export interface ContentSort {
  /**
   * sort type
   * @default "DESC"
   */
  order?: "ASC" | "DESC";
  /**
   * sort field
   * @default "ISSUE_DATE"
   */
  field?: "ISSUE_DATE";
}

export interface SearchSingleOpenDataRequest {
  /** open data type */
  type?: OpenDataTypeEnum;
  /** query keyword string */
  keyword: string;
  /**
   * query operator
   * @default "MATCH"
   */
  operator?: "MATCH" | "PREFIX" | "EXACT";
  query?: OpenDataQuery;
  /**
   * query limit
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /**
   * query offset
   * @default 0
   */
  offset?: number;
  /** @default "en-US" */
  language?: string;
  market?: string;
  /** open data type */
  sub_type?: OpenDataTypeEnum;
}

export type EtfHoldingsOverviewResponse = BaseResponse & {
  /** ETF holdings overview */
  data?: EtfHoldingsOverview;
};

/** ETF holdings overview */
export interface EtfHoldingsOverview {
  /**
   * Total number of holdings
   * @format int32
   */
  total_holdings_count?: number;
  /** Sector weight list */
  sector_weights?: SectorWeight[];
  /** Asset allocation list */
  asset_allocation?: AssetAllocation[];
  /** Assets under management (AUM) */
  aum?: number;
  /** Holdings data date (yyyy-MM-dd) */
  holdings_date?: string;
}

export interface SectorWeight {
  /** Sector name */
  sector?: string;
  /** Weight percentage */
  percentage?: number;
}

export interface AssetAllocation {
  /** Asset type (e.g. Equity, Bond, Cash) */
  type?: string;
  /** Weight percentage */
  percentage?: number;
}

export type EtfHoldingsPaginationResponse = BaseResponse & {
  data?: EtfHoldingsPagination;
};

export interface EtfHoldingsPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  /** next page token */
  next_token?: string;
  rows?: EtfHolding[];
}

/** Single ETF holding */
export interface EtfHolding {
  /** Holding symbol */
  symbol?: string;
  /** Holding name */
  name?: string;
  /** Weight in portfolio */
  weight?: number;
  /**
   * Market value
   * @format int64
   */
  market_value?: number;
  /**
   * Shares held
   * @format int64
   */
  shares?: number;
  /** Current price */
  current_price?: number;
  /** Previous trading day closing price */
  previous_close?: number;
  /**
   * Shares change from previous trading day (current shares - previous day shares)
   * @format int64
   */
  shares_change?: number;
  /** Shares change percentage from previous trading day */
  shares_change_percent?: number;
  /** Stock market */
  market?: string;
}

export interface EtfProfileRequest {
  /**
   * Language code for multi-language fields (e.g. en-US, zh-CN)
   * @default "en-US"
   */
  language?: string;
  enrich?: EtfEnrichOption;
}

export interface EtfEnrichOption {
  /**
   * If you need to return the performance returns data, set this to true.
   * @default false
   */
  with_performance?: boolean;
}

export type EtfProfileResponse = BaseResponse & {
  /** ETF profile */
  data?: EtfProfile;
};

/** ETF profile */
export interface EtfProfile {
  /** ETF symbol (e.g. SPY) */
  symbol?: string;
  /** ETF name */
  name?: string;
  /** Short description */
  description?: string;
  /** Long description */
  long_description?: string;
  /** Net asset value (NAV) */
  nav?: number;
  /** Assets under management (AUM) */
  aum?: number;
  /**
   * Shares outstanding
   * @format int64
   */
  shares_outstanding?: number;
  /** Expense ratio */
  expense_ratio?: number;
  /** Tracking index name (e.g. S&P 500), from data source */
  tracking_index?: string;
  /** Annualized tracking error; active return std dev × √252, null if benchmark unavailable */
  tracking_error?: number;
  /** Benchmark index latest close (current price proxy), null if benchmark unavailable */
  tracking_index_current_price?: number;
  /** Benchmark index previous trading day close, null if benchmark unavailable */
  tracking_index_previous_close?: number;
  /** Issuer or fund manager */
  issuer?: string;
  /** Inception date (yyyy-MM-dd) */
  inception_date?: string;
  /** Dividend policy or pay frequency */
  dividend_policy?: string;
  /** Investment segment label in the requested language (filtered by request language parameter) */
  investment_segment?: string;
  /** Performance returns data (enriched when enrich.with_performance is true) */
  performance?: EtfPerformance;
}

/** ETF performance */
export interface EtfPerformance {
  /** Returns data */
  returns?: EtfReturns;
}

/** ETF returns */
export interface EtfReturns {
  /** Year-to-date return */
  ytd?: number;
  /** 1-year return */
  one_year?: number;
  /** 3-year return */
  three_year?: number;
  /** 5-year return */
  five_year?: number;
}

export type StockSplitPaginationResponse = BaseResponse & {
  data?: StockSplitPagination;
};

export interface StockSplitPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  /** next page token */
  next_token?: string;
  rows?: StockSplit[];
}

/** Stock split or reverse split record */
export interface StockSplit {
  /** Effective date (yyyy-MM-dd) */
  date?: string;
  /**
   * Split ratio numerator
   * @format int32
   */
  numerator?: number;
  /**
   * Split ratio denominator
   * @format int32
   */
  denominator?: number;
  /** Type (e.g. split, reverse split) */
  split_type?: string;
}

export type DividendPaginationResponse = BaseResponse & {
  data?: DividendPagination;
};

export interface DividendPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /**
   * page offset
   * @format int32
   */
  offset?: number;
  /** next page token */
  next_token?: string;
  rows?: Dividend[];
}

export interface ListPeopleRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @format int32
   * @max 20
   * @default 10
   */
  limit?: number;
  /** people' IDs, comma-separated if querying more than 1 people. */
  ids?: string[];
  /** people' handles, comma-separated if querying more than 1 people. */
  handles?: string[];
  query?: OpenDataQuery;
  enrich?: PeopleEnrichOption;
}

export interface ListTokenRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @format int32
   * @max 20
   * @default 10
   */
  limit?: number;
  /** token's IDs, comma-separated if querying more than 1 token. */
  ids?: string[];
  /** token's symbol, comma-separated if querying more than 1 token. */
  symbols?: string[];
  /** token's name, comma-separated if querying more than 1 token. */
  names?: string[];
  /** token's address, comma-separated if querying more than 1 token. */
  addresses?: string[];
  /** token's tag, comma-separated if querying more than 1 tag. */
  tags?: string[];
  /** token's web slug, comma-separated if querying more than 1 token. */
  web_slugs?: string[];
  /**
   * return top 1 token or return all tokens
   * @default "TOP"
   */
  include?: "TOP" | "ALL";
  sort?: TokenSort;
  enrich?: TokenEnrichOption;
  /** language */
  language?: string;
}

export interface TokenSort {
  /**
   * sort type
   * @default "DESC"
   */
  order?: "ASC" | "DESC";
  /**
   * sort field
   * @default "MARKET_CAP"
   */
  field?: TokenSortField;
}

export interface ADXEnrichOption {
  /**
   * If you need to return the ADX information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 14. The number of data points used to calculate the ADX.
   * @format int32
   * @default 14
   */
  time_period?: number;
}

export interface CCIEnrichOption {
  /**
   * If you need to return the CCI information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 20. The number of data points used to calculate the CCI.
   * @format int32
   * @default 20
   */
  time_period?: number;
}

export interface DPOEnrichOption {
  /**
   * If you need to return the DPO information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 20. The number of data points used to calculate the DPO.
   * @format int32
   * @default 20
   */
  time_period?: number;
}

export interface EMAEnrichOption {
  /**
   * If you need to return the EMA information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** Optional. Default is 6. The number of data points used to calculate the EMA. */
  time_period?: number[];
}

export interface RSIEnrichOption {
  /**
   * If you need to return the RSI information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** Optional. Default is 14. The number of data points used to calculate RSI. Common values include 6, 12, and 24. */
  time_period?: number[];
}

export interface MAEnrichOption {
  /**
   * If you need to return the MA information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** Optional. Usually set to 30. The number of data points used to calculate the moving average. */
  time_period?: number[];
  /**
   * Optional. Default is EMA. The moving average type.
   * @default "EMA"
   */
  ma_type?: "EMA" | "SMA" | "WMA";
}

export interface MACDEnrichOption {
  /**
   * If you need to return the MACD information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 12. The number of data points used to calculate the fast EMA.
   * @format int32
   * @default 12
   */
  fast_period?: number;
  /**
   * Optional. Default is 26. The number of data points used to calculate the slow EMA.
   * @format int32
   * @default 26
   */
  slow_period?: number;
  /**
   * Optional. Default is 9. The number of data points used to calculate the signal line.
   * @format int32
   * @default 9
   */
  signal_period?: number;
}

export interface BBandsEnrichOption {
  /**
   * If you need to return the BBands information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is 5. The number of data points used to calculate the moving average and standard deviation. Typically set to 20.
   * @format int32
   * @default 5
   */
  time_period?: number;
  /**
   * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
   * @format int32
   * @default 2
   */
  nb_dev_up?: number;
  /**
   * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
   * @format int32
   * @default 2
   */
  nb_dev_dn?: number;
  /**
   * Optional. Default is EMA. The moving average type.
   * @default "EMA"
   */
  ma_type?: "EMA" | "SMA" | "WMA";
}

export interface MarketDataEnrichOption {
  /**
   * If you need to return the markets information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Optional. Default is market_cap_change_percentage_24h.
   * @default "market_cap_change_percentage_24h"
   */
  sort?:
    | "volume"
    | "market_cap"
    | "price"
    | "market_cap_change_percentage_24h"
    | "last_updated";
}

export interface OHLCEnrichOption {
  /**
   * If you need to return the sparkline information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * On or after a specified unix timestamp in milliseconds.
   * @format int64
   */
  start_time?: number;
  /**
   * Before a specified unix timestamp in milliseconds.
   * @format int64
   */
  end_time?: number;
  /**
   * Data aggregation time interval. Supported values [ 5m,1h,4h,12h,1d,1w ]
   * @default "1h"
   */
  interval?: string;
}

export interface HolderEnrichOption {
  /**
   * If you need to return the token holder information (count & distribution_percentage), set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * If you need to return the token top holder detail infos ,set this to a number between 0 and x, x is api_config.
   * @min 0
   * @max 100
   * @default 0
   */
  top_holders_limit?: number;
}

export interface SentimentEnrichOption {
  /**
   * If you need to return the sentiment information, set this to true.
   * @default false
   */
  enable?: boolean;
}

export interface FlowEnrichOption {
  /**
   * If you need to return the flow information include netflow, inflow, outflow, set this to true.
   * @default false
   */
  enable?: boolean;
  /** time periods, eg. ["1d", "7d", "30d"] */
  time_periods?: string[];
}

export interface SparklineEnrichOption {
  /**
   * If you need to return the trading data, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * allowed values[1m, 15m, 1h]
   * @default "1m"
   */
  interval?: string;
  /**
   * the number of trading days to query. Allowed values[1d , 5d , 7d, 30d]
   * @default "1d"
   */
  trading_period?: string;
}

/** token listing info */
export interface Listing {
  /** token listing exchange name */
  exchange?: string;
  /**
   * listing date
   * @format int64
   */
  date?: number;
  /** listing url */
  url?: string;
}

/** Trend Analysis */
export interface TrendAnalysis {
  /** Trend type, "uptrend" (上升) or "downtrend" (下降) */
  trend_type?: string;
  /**
   * Start timestamp of the continuous trend segment (milliseconds)
   * @format int64
   */
  start_time?: number;
  /**
   * Total change percentage ((end-start)/start*100), rounded to 2 decimal places
   * @format double
   */
  total_change_percent?: number;
}

export interface ListStockRequest {
  /**
   * The offset of the first item to return
   * @default 0
   */
  offset?: number;
  /**
   * The maximum number of items to return
   * @default 10
   */
  limit?: number;
  symbols?: string[];
  ids?: string[];
  enrich?: StockEnrichOption;
  /** stock market */
  market?: StockMarketEnum;
  /** language */
  language?: string;
}

export interface StockEnrichOption {
  /**
   * If you need to return the token relative information, set this to true.
   * @default false
   */
  enable?: boolean;
  /** If you need to return the asset must include types, set this to specific types. */
  include_types?: string[];
  with_sparkline?: SparklineEnrichOption;
  /**
   * If you need to return the trading data, set this to true.
   * @default false
   */
  with_trading_data?: boolean;
  /**
   * If you need to return the price forecast, set this to true.
   * @default false
   */
  with_target_price?: boolean;
  /** If you need to return the OHLCV data, set this to true. */
  with_ohlcv?: OHLCVEnrichOption;
  /**
   * If you need to return the recommendation trend, set this to true.
   * @default false
   */
  with_recommendation_trend?: boolean;
  /**
   * If you need to return the rating data, set this to true.
   * @default false
   */
  with_rating?: boolean;
  /** If you need to return the historical earnings data, set this to true. */
  with_earnings?: EarningsEnrichOption;
  /** If you need to return the revenue estimate data, set this to true. */
  with_revenue_estimates?: RevenueEstimateEnrichOption;
  /** If you need to return the earning quality score data, set this to true. */
  with_earning_scores?: EarningScoreEnrichOption;
  /** If you need to return the historical dividends data, set this to true. */
  with_dividends?: DividendEnrichOption;
  /** If you need to return the financial statements data, set this to true. */
  with_financials?: FinancialEnrichOption;
  /** If you need to return the revenue breakdown data, set this to true. */
  with_revenue_breakdown?: RevenueBreakdownEnrichOption;
  with_stochastic?: StochasticEnrichOption;
  with_trend_analysis?: TrendAnalysisEnrichOption;
}

export interface OHLCVEnrichOption {
  /**
   * If you need to return the OHLCV information, set this to true.
   * @default false
   */
  enable?: boolean;
  /**
   * Data aggregation time interval. Supported values [ 1m,15m,1h,1d ]
   * @default "1d"
   */
  interval?: string;
  /**
   * Data aggregation time period. Supported values [ 1d,5d,7d,30d,365d ]
   * @default "1d"
   */
  period?: string;
}

export interface EarningsEnrichOption {
  /**
   * Whether to return historical earnings data, defaults to past 12 quarters
   * @default false
   */
  enable?: boolean;
  /**
   * Earnings limit
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface RevenueEstimateEnrichOption {
  /**
   * Whether to return revenue estimate data
   * @default false
   */
  enable?: boolean;
  /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
  freq?: FinancialFrequency;
  /**
   * Revenue data limit
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface EarningScoreEnrichOption {
  /**
   * Whether to return earning quality score data
   * @default false
   */
  enable?: boolean;
  /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
  freq?: FinancialFrequency;
  /**
   * Earnings score limit
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface DividendEnrichOption {
  /**
   * Whether to return historical dividends data
   * @default false
   */
  enable?: boolean;
  /**
   * Dividends limit
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface FinancialEnrichOption {
  /**
   * Whether to return financial data
   * @default false
   */
  enable?: boolean;
  /**
   * Financial data limit
   * @max 50
   * @default 10
   */
  limit?: number;
  /**
   * If you need to return the ttm data, set this to true.
   * @default false
   */
  ttm?: boolean;
  /** Financial statement type, IC for income statement, BS for balance sheet, CF for cash flow statement */
  statements?: ("IC" | "BS" | "CF")[];
  /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
  freq?: FinancialFrequency;
}

export interface RevenueBreakdownEnrichOption {
  /**
   * Whether to return revenue breakdown data
   * @default false
   */
  enable?: boolean;
  /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
  freq?: FinancialFrequency;
  /** Group types, GEOGRAPHY for geography grouping, PRODUCT for product grouping */
  groups?: ("GEOGRAPHY" | "PRODUCT")[];
}

export interface GetRankingStockRequest {
  /**
   * @format int32
   * @default 0
   */
  offset?: number;
  /**
   * @format int32
   * @default 10
   */
  limit?: number;
  themes?: string[];
  /** theme ids */
  theme_ids?: string[];
  /** @deprecated */
  theme?: string;
  sort?: StockSort;
  type?: "REPORT_360";
  enrich?: StockEnrichOption;
  /** JSON string for StockDynamicFilter */
  filters?: string[];
  /** stock market */
  market?: StockMarketEnum;
  /** language */
  language?: string;
}

export interface StockSort {
  /** sort type */
  order?: "ASC" | "DESC";
  /** sort field */
  field?: StockSortField;
}

/** Backward-compatible holding (POSITION_ASSET only) */
export interface PortfolioHolding {
  /** Asset symbol */
  symbol?: string;
  /** Asset ID */
  asset_id?: string;
  /** Asset name */
  name?: string;
  /** Asset type */
  asset_type?: "STOCK" | "TOKEN";
  /** Position quantity */
  quantity?: number;
  /** Average cost */
  avgCost?: number;
  /** Current price */
  currentPrice?: number;
  /** Market value */
  marketValue?: number;
  /** Profit/loss amount */
  profitLoss?: number;
  /** Profit/loss percent */
  profitLossPercent?: number;
  /** Currency */
  currency?: string;
  /** Recognition confidence */
  confidence?: "high" | "medium" | "low";
}

export interface RecognizedFinancialRecord {
  /** Financial record type */
  recordType:
    | "POSITION_ASSET"
    | "POSITION_ORDER"
    | "ACCOUNT_BALANCE"
    | "BANK_TRANSACTION"
    | "LIABILITY"
    | "OTHER_ASSET";
  /** Recognition confidence for this record */
  confidence: "high" | "medium" | "low";
  symbol?: string;
  /** Asset ID from search_assets (asset_router_id) */
  assetId?: string;
  assetName?: string;
  /** equity, etf, mutual_fund, cryptocurrency, etc. */
  assetType?: string;
  quantity?: number;
  avgCost?: number;
  currentPrice?: number;
  marketValue?: number;
  side?: "buy" | "sell";
  price?: number;
  /** @format date-time */
  orderTime?: string;
  value?: number;
  accountName?: string;
  /** depository, investment, credit, loan */
  accountType?: string;
  /** checking, savings, brokerage, credit card, etc. */
  accountSubtype?: string;
  currentBalance?: number;
  availableBalance?: number;
  creditLimit?: number;
  /** @format date */
  transactionDate?: string;
  /** Transaction amount (negative = expense) */
  amount?: number;
  description?: string;
  merchantName?: string;
  category?: string;
  /** mortgage, student, auto, credit_card */
  liabilityType?: string;
  outstandingPrincipal?: number;
  interestRate?: number;
  minimumPayment?: number;
  /** @format date */
  nextPaymentDate?: string;
  assetCategory?:
    | "REAL_ESTATE"
    | "VEHICLE"
    | "BUSINESS_EQUITY"
    | "COLLECTIBLE"
    | "OTHER";
  estimatedValue?: number;
  currency?: string;
}

/** Provide either imageUrls (1-5 screenshots) or pdfUrls (1-5 PDF files, max 20MB each), but not both. At least one array must be non-empty. */
export interface PortfolioRecognizeRequest {
  /**
   * Screenshot URLs (attachment-temp:// recommended)
   * @maxItems 5
   * @minItems 1
   */
  imageUrls?: string[];
  /**
   * PDF URLs only (attachment-temp:// recommended, max 20MB per file)
   * @maxItems 5
   * @minItems 1
   */
  pdfUrls?: string[];
  language?: string;
}

export interface PortfolioRecognizeData {
  /** Backward-compatible holdings list (POSITION_ASSET only) */
  holdings?: PortfolioHolding[];
  /** Multi-type financial records (primary field for frontend) */
  records?: RecognizedFinancialRecord[];
  /** Inferred document type */
  documentType?:
    | "brokerage_statement"
    | "bank_statement"
    | "credit_card_statement"
    | "loan_statement"
    | "net_worth_summary"
    | "portfolio_screenshot"
    | "other"
    | "unknown";
  parseConfidence?: "high" | "medium" | "low";
  /** Count of unrecognized entries */
  unrecognizedCount?: number;
}

export interface PortfolioError {
  code?: string;
  message?: string;
}

export interface PortfolioRecognizeResponse {
  success: boolean;
  data?: PortfolioRecognizeData;
  error?: PortfolioError;
}

/** Provide either `records` (multi-type financial records, preferred) or `holdings` (legacy position-only format). At least one array must be non-empty. */
export interface PortfolioSaveRequest {
  /**
   * Multi-type financial records to persist (preferred)
   * @minItems 1
   */
  records?: RecognizedFinancialRecord[];
  /**
   * Backward-compatible holdings list
   * @minItems 1
   */
  holdings?: {
    /** Asset ID */
    asset_id: string;
    /** Asset type */
    asset_type: "STOCK" | "TOKEN";
    /** Asset symbol (optional) */
    symbol?: string;
    /** Position quantity */
    quantity?: number;
    /** Average cost */
    avgCost?: number;
    /** Currency */
    currency?: string;
  }[];
}

export interface PortfolioSaveRecordStatus {
  recordType?: string;
  status?: "saved" | "skipped" | "failed";
  error?: string;
}

export interface PortfolioSaveData {
  /** Primary Financial Account ID */
  accountId?: string;
  /** Number of records saved successfully */
  savedCount?: number;
  /** Save counts grouped by recordType */
  savedByType?: Record<string, number>;
  /** Per-record save status */
  records?: PortfolioSaveRecordStatus[];
}

export interface PortfolioSaveResponse {
  success: boolean;
  data?: PortfolioSaveData;
  error?: PortfolioError;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Open Social API
 * @version 2.0.0
 *
 * The platform API for Open Social Project
 */
export class OpenDataClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  ecosystems = {
    /**
     * @description query project
     *
     * @tags OpenEcosystem
     * @name GetEcosystemRanking
     * @summary /ecosystem/ranking
     * @request GET:/ecosystems/ranking
     * @secure
     */
    getEcosystemRanking: (
      query?: {
        /**
         * offset
         * @format int32
         * @min 0
         * @max 20
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @format int32
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /** ecosystem ranking type */
        type?: "TVL" | "TVL_7D_CHANGE_PERCENT";
      },
      params: RequestParams = {},
    ) =>
      this.request<EcosystemPaginationResponse, any>({
        path: `/ecosystems/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contents = {
    /**
     * @description query contents
     *
     * @tags OpenContent
     * @name GetContents
     * @summary /contents
     * @request GET:/contents
     * @secure
     */
    getContents: (
      query?: {
        /**
         * offset
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @format int32
         * @max 50
         * @default 10
         */
        limit?: number;
        /** content type */
        type?: ContentTypeEnum;
        /** content category */
        category?: ContentCategoryEnum;
        /** people' IDs, comma-separated if querying more than 1 people. */
        ids?: string[];
        /** query conditions array */
        "query.conditions"?: OpenDataQueryCondition[];
        /**
         * query condition type
         * @default "AND"
         */
        "query.condition_type"?: "AND" | "OR";
        /**
         * If you need to return the post relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the people relative information, set this to true.
         * @default false
         */
        "enrich.with_people.enable"?: boolean;
        /**
         * fill x's posts count
         * @min 0
         * @max 20
         * @default 0
         */
        "enrich.with_people.with_x_content_count"?: number;
        /** include some social metrics, such as ... */
        "enrich.with_people.with_social_metrics"?: boolean;
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.with_token.enable"?: boolean;
        /**
         * if need to return some social metrics, set this to true
         * @default false
         */
        "enrich.with_token.with_social_metrics"?: boolean;
        /**
         * If you need to include the liquidity pools where this token can be traded, set this to true.
         * @default false
         */
        "enrich.with_token.with_pool"?: boolean;
        /**
         * If you need to return the network relative information, set this to true
         * @default false
         */
        "enrich.with_token.with_network"?: boolean;
        "enrich.with_token.with_adx"?: string;
        "enrich.with_token.with_cci"?: string;
        "enrich.with_token.with_dpo"?: string;
        "enrich.with_token.with_ema"?: string;
        "enrich.with_token.with_rsi"?: string;
        "enrich.with_token.with_ma"?: string;
        "enrich.with_token.with_macd"?: string;
        "enrich.with_token.with_bbands"?: string;
        "enrich.with_token.with_market"?: string;
        "enrich.with_token.with_ohlc"?: string;
        "enrich.with_token.with_holder"?: string;
        "enrich.with_token.with_sentiment"?: string;
        "enrich.with_token.with_flow"?: string;
        /**
         * If you need to return the team members information, set this to true
         * @default false
         */
        "enrich.with_token.with_team"?: boolean;
        /**
         * If you need to return the investors information, set this to true
         * @default false
         */
        "enrich.with_token.with_investor"?: boolean;
        /**
         * If you need to return supporting exchanges list, set this to true
         * @default false
         */
        "enrich.with_token.with_exchange"?: boolean;
        /**
         * If you need to return the ticker information, set this to true
         * @default false
         */
        "enrich.with_token.with_ticker"?: boolean;
        /**
         * If you need to return just the 360 report list, set this to true
         * @default false
         */
        "enrich.with_token.with_rating"?: boolean;
        "enrich.with_token.with_sparkline"?: string;
        /**
         * If you need to return the funding rate, set this to true
         * @default false
         */
        "enrich.with_token.with_funding_rate"?: boolean;
        /**
         * If you need to return the post relative information, set this to true.
         * @default false
         */
        "enrich.with_symbol.enable"?: boolean;
        /**
         * if need to return price information
         * @default false
         */
        "enrich.with_symbol.with_price"?: boolean;
        /**
         * language code
         * @default "en-US"
         */
        language?: string;
        /** the insight source links query */
        source_links?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ContentPaginationResponse, any>({
        path: `/contents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query contents
     *
     * @tags OpenContent
     * @name GetRankingContents
     * @summary /contents/ranking
     * @request GET:/contents/ranking
     * @secure
     */
    getRankingContents: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /** category */
        category?: ContentCategoryEnum;
        /** content type */
        type?: ContentTypeEnum;
        /** author' handles, comma-separated if querying more than 1 people. */
        authors?: string[];
        /** The handles mentioned in the post */
        mentions?: string[];
        /** The symbols mentioned in the post */
        symbols?: string[];
        /** content theme，'Other' is a special theme only return contents without themes */
        themes?: string[];
        /** theme ids */
        themeIds?: string[];
        /** HIGH/LOW, used to distinguish pinned Article content */
        level?: string;
        /** themes to exclude */
        exclude_themes?: string[];
        /**
         * If you need to return the post relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the people relative information, set this to true.
         * @default false
         */
        "enrich.with_people.enable"?: boolean;
        /**
         * fill x's posts count
         * @min 0
         * @max 20
         * @default 0
         */
        "enrich.with_people.with_x_content_count"?: number;
        /** include some social metrics, such as ... */
        "enrich.with_people.with_social_metrics"?: boolean;
        /**
         * If you need to return the post relative information, set this to true.
         * @default false
         */
        "enrich.with_symbol.enable"?: boolean;
        /** @default false */
        "enrich.with_symbol.with_price"?: boolean;
        /**
         * sort type
         * @default "DESC"
         */
        "sort.order"?: "ASC" | "DESC";
        /**
         * sort field
         * @default "ISSUE_DATE"
         */
        "sort.field"?: "ISSUE_DATE";
        /**
         * On or after a specified unix timestamp in milliseconds.
         * @format int64
         */
        start_time?: number;
        /**
         * Before a specified unix timestamp in milliseconds.
         * @format int64
         */
        end_time?: number;
        /** @default "en-US" */
        language?: string;
        /** US,HK */
        market?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContentPaginationResponse, any>({
        path: `/contents/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  themes = {
    /**
     * @description query themes @type GetRankingThemeRequest
     *
     * @tags OpenTheme
     * @name GetRankingThemes
     * @summary /themes/ranking
     * @request GET:/themes/ranking
     * @secure
     */
    getRankingThemes: (
      query?: {
        /**
         * page offset
         * @format int32
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * request data count
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** theme data type */
        type?: OpenDataTypeEnum;
        /** theme ids */
        ids?: string[];
        /** theme slugs (name_en) */
        slugs?: string[];
        /** theme scope (hotSearch, heatmap, recommend) */
        scope?: string;
        /** market (US, HK) */
        market?: string;
        /** @default "en-US" */
        language?: string;
        /**
         * enable enrichment
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * enable market data
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * content language
         * @default "en-US"
         */
        "enrich.with_market.language"?: string;
        /**
         * enable symbol data
         * @default false
         */
        "enrich.with_symbol.enable"?: boolean;
        /**
         * symbol limit
         * @format int32
         * @min 0
         * @default 0
         */
        "enrich.with_symbol.limit"?: number;
        /** @default "PRICE_CHANGE_24H" */
        "enrich.with_symbol.sort.field"?:
          | "MANUAL"
          | "MARKET_CAP"
          | "PRICE_CHANGE_24H"
          | "TOP";
        "enrich.with_symbol.sort.order"?: "ASC" | "DESC";
        /**
         * enable content data
         * @default false
         */
        "enrich.with_content.enable"?: boolean;
        /**
         * content limit
         * @format int32
         * @min 0
         * @default 0
         */
        "enrich.with_content.limit"?: number;
        /**
         * content language
         * @default "en-US"
         */
        "enrich.with_content.language"?: string;
        /** @default "PRICE_CHANGE_24H" */
        "sort.field"?: "MANUAL" | "MARKET_CAP" | "PRICE_CHANGE_24H" | "TOP";
        "sort.order"?: "ASC" | "DESC";
      },
      params: RequestParams = {},
    ) =>
      this.request<ThemeItemPaginationResponse, any>({
        path: `/themes/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query themes @type GetThemeRequest
     *
     * @tags OpenTheme
     * @name GetThemes
     * @summary /themes
     * @request GET:/themes
     * @secure
     */
    getThemes: (
      query?: {
        /**
         * page offset
         * @format int32
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * request data count
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** theme data type */
        type?: OpenDataTypeEnum;
        /** theme ids */
        ids?: string[];
        /** theme slugs (name_en) */
        slugs?: string[];
        /** theme types (hotSearch, heatmap, recommend) */
        scopes?: string[];
        /** market (US, HK) */
        market?: string;
        /**
         * theme names array
         * @maxItems 20
         * @minItems 0
         */
        names?: string[];
        /**
         * enable enrichment
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * enable market data
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * content language
         * @default "en-US"
         */
        "enrich.with_market.language"?: string;
        /**
         * enable symbol data
         * @default false
         */
        "enrich.with_symbol.enable"?: boolean;
        /**
         * symbol limit
         * @format int32
         * @min 0
         * @default 0
         */
        "enrich.with_symbol.limit"?: number;
        /** @default "PRICE_CHANGE_24H" */
        "enrich.with_symbol.sort.field"?:
          | "MANUAL"
          | "MARKET_CAP"
          | "PRICE_CHANGE_24H"
          | "TOP";
        "enrich.with_symbol.sort.order"?: "ASC" | "DESC";
        /**
         * enable content data
         * @default false
         */
        "enrich.with_content.enable"?: boolean;
        /**
         * content limit
         * @format int32
         * @min 0
         * @default 0
         */
        "enrich.with_content.limit"?: number;
        /**
         * content language
         * @default "en-US"
         */
        "enrich.with_content.language"?: string;
        /** @default "en-US" */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThemeItemPaginationResponse, any>({
        path: `/themes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tokens = {
    /**
     * @description query token
     *
     * @tags OpenToken
     * @name GetTokens
     * @summary /tokens
     * @request GET:/tokens
     * @secure
     */
    getTokens: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @max 20
         * @default 10
         */
        limit?: number;
        /** token's IDs, comma-separated if querying more than 1 token. */
        ids?: string[];
        /** token's symbol, comma-separated if querying more than 1 token. */
        symbols?: string[];
        /** token's name, comma-separated if querying more than 1 token. */
        names?: string[];
        /** token's address, comma-separated if querying more than 1 token. */
        addresses?: string[];
        /** token's tag, comma-separated if querying more than 1 tag. */
        tags?: string[];
        /** token's web slug, comma-separated if querying more than 1 token. */
        web_slugs?: string[];
        /**
         * return top 1 token or return all tokens
         * @default "TOP"
         */
        include?: "TOP" | "ALL";
        /**
         * sort type
         * @default "DESC"
         */
        "sort.order"?: "ASC" | "DESC";
        /**
         * sort field
         * @default "MARKET_CAP"
         */
        "sort.field"?: TokenSortField;
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * if need to return some social metrics, set this to true
         * @default false
         */
        "enrich.with_social_metrics"?: boolean;
        /**
         * If you need to include the liquidity pools where this token can be traded, set this to true.
         * @default false
         */
        "enrich.with_pool"?: boolean;
        /**
         * If you need to return the network relative information, set this to true
         * @default false
         */
        "enrich.with_network"?: boolean;
        /** If you need to return the asset must include types, set this to specific types. */
        "enrich.include_types"?: string[];
        /**
         * If you need to return the ADX information, set this to true.
         * @default false
         */
        "enrich.with_adx.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate the ADX.
         * @format int32
         * @default 14
         */
        "enrich.with_adx.time_period"?: number;
        /**
         * If you need to return the CCI information, set this to true.
         * @default false
         */
        "enrich.with_cci.enable"?: boolean;
        /**
         * Optional. Default is 20. The number of data points used to calculate the CCI.
         * @format int32
         * @default 20
         */
        "enrich.with_cci.time_period"?: number;
        /**
         * If you need to return the DPO information, set this to true.
         * @default false
         */
        "enrich.with_dpo.enable"?: boolean;
        /**
         * Optional. Default is 20. The number of data points used to calculate the DPO.
         * @format int32
         * @default 20
         */
        "enrich.with_dpo.time_period"?: number;
        /**
         * If you need to return the EMA information, set this to true.
         * @default false
         */
        "enrich.with_ema.enable"?: boolean;
        /** Optional. Default is 6. The number of data points used to calculate the EMA. */
        "enrich.with_ema.time_period"?: number[];
        /**
         * If you need to return the RSI information, set this to true.
         * @default false
         */
        "enrich.with_rsi.enable"?: boolean;
        /** Optional. Default is 14. The number of data points used to calculate RSI. Common values include 6, 12, and 24. */
        "enrich.with_rsi.time_period"?: number[];
        /**
         * If you need to return the MA information, set this to true.
         * @default false
         */
        "enrich.with_ma.enable"?: boolean;
        /** Optional. Usually set to 30. The number of data points used to calculate the moving average. */
        "enrich.with_ma.time_period"?: number[];
        /**
         * Optional. Default is EMA. The moving average type.
         * @default "EMA"
         */
        "enrich.with_ma.ma_type"?: "EMA" | "SMA" | "WMA";
        /**
         * If you need to return the MACD information, set this to true.
         * @default false
         */
        "enrich.with_macd.enable"?: boolean;
        /**
         * Optional. Default is 12. The number of data points used to calculate the fast EMA.
         * @format int32
         * @default 12
         */
        "enrich.with_macd.fast_period"?: number;
        /**
         * Optional. Default is 26. The number of data points used to calculate the slow EMA.
         * @format int32
         * @default 26
         */
        "enrich.with_macd.slow_period"?: number;
        /**
         * Optional. Default is 9. The number of data points used to calculate the signal line.
         * @format int32
         * @default 9
         */
        "enrich.with_macd.signal_period"?: number;
        /**
         * If you need to return the BBands information, set this to true.
         * @default false
         */
        "enrich.with_bbands.enable"?: boolean;
        /**
         * Optional. Default is 5. The number of data points used to calculate the moving average and standard deviation. Typically set to 20.
         * @format int32
         * @default 5
         */
        "enrich.with_bbands.time_period"?: number;
        /**
         * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
         * @format int32
         * @default 2
         */
        "enrich.with_bbands.nb_dev_up"?: number;
        /**
         * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
         * @format int32
         * @default 2
         */
        "enrich.with_bbands.nb_dev_dn"?: number;
        /**
         * Optional. Default is EMA. The moving average type.
         * @default "EMA"
         */
        "enrich.with_bbands.ma_type"?: "EMA" | "SMA" | "WMA";
        /**
         * If you need to return the markets information, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * Optional. Default is market_cap_change_percentage_24h.
         * @default "market_cap_change_percentage_24h"
         */
        "enrich.with_market.sort"?:
          | "volume"
          | "market_cap"
          | "price"
          | "market_cap_change_percentage_24h"
          | "last_updated";
        /**
         * If you need to return the sparkline information, set this to true.
         * @default false
         */
        "enrich.with_ohlc.enable"?: boolean;
        /**
         * On or after a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.start_time"?: number;
        /**
         * Before a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.end_time"?: number;
        /**
         * Data aggregation time interval. Supported values [ 5m,1h,4h,12h,1d,1w ]
         * @default "1h"
         */
        "enrich.with_ohlc.interval"?: string;
        /**
         * If you need to return the token holder information (count & distribution_percentage), set this to true.
         * @default false
         */
        "enrich.with_holder.enable"?: boolean;
        /**
         * If you need to return the token top holder detail infos ,set this to a number between 0 and x, x is api_config.
         * @min 0
         * @max 100
         * @default 0
         */
        "enrich.with_holder.top_holders_limit"?: number;
        /**
         * If you need to return the sentiment information, set this to true.
         * @default false
         */
        "enrich.with_sentiment.enable"?: boolean;
        /**
         * If you need to return the flow information include netflow, inflow, outflow, set this to true.
         * @default false
         */
        "enrich.with_flow.enable"?: boolean;
        /** time periods, eg. ["1d", "7d", "30d"] */
        "enrich.with_flow.time_periods"?: string[];
        /**
         * If you need to return the team members information, set this to true
         * @default false
         */
        "enrich.with_team"?: boolean;
        /**
         * If you need to return the investors information, set this to true
         * @default false
         */
        "enrich.with_investor"?: boolean;
        /**
         * If you need to return supporting exchanges list, set this to true
         * @default false
         */
        "enrich.with_exchange"?: boolean;
        /**
         * If you need to return the ticker information, set this to true
         * @default false
         */
        "enrich.with_ticker"?: boolean;
        /**
         * If you need to return just the 360 report list, set this to true
         * @default false
         */
        "enrich.with_rating"?: boolean;
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_sparkline.enable"?: boolean;
        /**
         * allowed values[1m, 15m, 1h]
         * @default "1m"
         */
        "enrich.with_sparkline.interval"?: string;
        /**
         * the number of trading days to query. Allowed values[1d , 5d , 7d, 30d]
         * @default "1d"
         */
        "enrich.with_sparkline.trading_period"?: string;
        /**
         * If you need to return the funding rate, set this to true
         * @default false
         */
        "enrich.with_funding_rate"?: boolean;
        /**
         * If you need to return the Stochastic information, set this to true.
         * @default false
         */
        "enrich.with_stochastic.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate Stochastic.
         * @format int32
         * @default 14
         */
        "enrich.with_stochastic.period"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %K.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_k"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %D.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_d"?: number;
        /**
         * If you need to return the Trend Analysis information, set this to true.
         * @default false
         */
        "enrich.with_trend_analysis.enable"?: boolean;
        /**
         * Optional. Default is 30. The number of data points used to calculate Trend Analysis.
         * @format int32
         * @default 30
         */
        "enrich.with_trend_analysis.time_period"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TokenPaginationResponse, any>({
        path: `/tokens`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query token ranking
     *
     * @tags OpenToken
     * @name GetTokensRanking
     * @summary /tokens/ranking
     * @request GET:/tokens/ranking
     * @secure
     */
    getTokensRanking: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @min 1
         * @max 50
         * @default 5
         */
        limit?: number;
        /** token's themes */
        themes?: string[];
        /** theme ids */
        themeIds?: string[];
        type?: "BLUE_CHIP" | "REPORT_360";
        /**
         * sort type
         * @default "DESC"
         */
        "sort.order"?: "ASC" | "DESC";
        /**
         * sort field
         * @default "MARKET_CAP"
         */
        "sort.field"?: TokenSortField;
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * if need to return some social metrics, set this to true
         * @default false
         */
        "enrich.with_social_metrics"?: boolean;
        /**
         * If you need to include the liquidity pools where this token can be traded, set this to true.
         * @default false
         */
        "enrich.with_pool"?: boolean;
        /**
         * If you need to return the network relative information, set this to true
         * @default false
         */
        "enrich.with_network"?: boolean;
        /** If you need to return the asset must include types, set this to specific types. */
        "enrich.include_types"?: string[];
        /**
         * If you need to return the ADX information, set this to true.
         * @default false
         */
        "enrich.with_adx.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate the ADX.
         * @format int32
         * @default 14
         */
        "enrich.with_adx.time_period"?: number;
        /**
         * If you need to return the CCI information, set this to true.
         * @default false
         */
        "enrich.with_cci.enable"?: boolean;
        /**
         * Optional. Default is 20. The number of data points used to calculate the CCI.
         * @format int32
         * @default 20
         */
        "enrich.with_cci.time_period"?: number;
        /**
         * If you need to return the DPO information, set this to true.
         * @default false
         */
        "enrich.with_dpo.enable"?: boolean;
        /**
         * Optional. Default is 20. The number of data points used to calculate the DPO.
         * @format int32
         * @default 20
         */
        "enrich.with_dpo.time_period"?: number;
        /**
         * If you need to return the EMA information, set this to true.
         * @default false
         */
        "enrich.with_ema.enable"?: boolean;
        /** Optional. Default is 6. The number of data points used to calculate the EMA. */
        "enrich.with_ema.time_period"?: number[];
        /**
         * If you need to return the RSI information, set this to true.
         * @default false
         */
        "enrich.with_rsi.enable"?: boolean;
        /** Optional. Default is 14. The number of data points used to calculate RSI. Common values include 6, 12, and 24. */
        "enrich.with_rsi.time_period"?: number[];
        /**
         * If you need to return the MA information, set this to true.
         * @default false
         */
        "enrich.with_ma.enable"?: boolean;
        /** Optional. Usually set to 30. The number of data points used to calculate the moving average. */
        "enrich.with_ma.time_period"?: number[];
        /**
         * Optional. Default is EMA. The moving average type.
         * @default "EMA"
         */
        "enrich.with_ma.ma_type"?: "EMA" | "SMA" | "WMA";
        /**
         * If you need to return the MACD information, set this to true.
         * @default false
         */
        "enrich.with_macd.enable"?: boolean;
        /**
         * Optional. Default is 12. The number of data points used to calculate the fast EMA.
         * @format int32
         * @default 12
         */
        "enrich.with_macd.fast_period"?: number;
        /**
         * Optional. Default is 26. The number of data points used to calculate the slow EMA.
         * @format int32
         * @default 26
         */
        "enrich.with_macd.slow_period"?: number;
        /**
         * Optional. Default is 9. The number of data points used to calculate the signal line.
         * @format int32
         * @default 9
         */
        "enrich.with_macd.signal_period"?: number;
        /**
         * If you need to return the BBands information, set this to true.
         * @default false
         */
        "enrich.with_bbands.enable"?: boolean;
        /**
         * Optional. Default is 5. The number of data points used to calculate the moving average and standard deviation. Typically set to 20.
         * @format int32
         * @default 5
         */
        "enrich.with_bbands.time_period"?: number;
        /**
         * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
         * @format int32
         * @default 2
         */
        "enrich.with_bbands.nb_dev_up"?: number;
        /**
         * Optional. Default is 2. The number of standard deviations used to calculate the upper and lower bands.
         * @format int32
         * @default 2
         */
        "enrich.with_bbands.nb_dev_dn"?: number;
        /**
         * Optional. Default is EMA. The moving average type.
         * @default "EMA"
         */
        "enrich.with_bbands.ma_type"?: "EMA" | "SMA" | "WMA";
        /**
         * If you need to return the markets information, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * Optional. Default is market_cap_change_percentage_24h.
         * @default "market_cap_change_percentage_24h"
         */
        "enrich.with_market.sort"?:
          | "volume"
          | "market_cap"
          | "price"
          | "market_cap_change_percentage_24h"
          | "last_updated";
        /**
         * If you need to return the sparkline information, set this to true.
         * @default false
         */
        "enrich.with_ohlc.enable"?: boolean;
        /**
         * On or after a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.start_time"?: number;
        /**
         * Before a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.end_time"?: number;
        /**
         * Data aggregation time interval. Supported values [ 5m,1h,4h,12h,1d,1w ]
         * @default "1h"
         */
        "enrich.with_ohlc.interval"?: string;
        /**
         * If you need to return the token holder information (count & distribution_percentage), set this to true.
         * @default false
         */
        "enrich.with_holder.enable"?: boolean;
        /**
         * If you need to return the token top holder detail infos ,set this to a number between 0 and x, x is api_config.
         * @min 0
         * @max 100
         * @default 0
         */
        "enrich.with_holder.top_holders_limit"?: number;
        /**
         * If you need to return the sentiment information, set this to true.
         * @default false
         */
        "enrich.with_sentiment.enable"?: boolean;
        /**
         * If you need to return the flow information include netflow, inflow, outflow, set this to true.
         * @default false
         */
        "enrich.with_flow.enable"?: boolean;
        /** time periods, eg. ["1d", "7d", "30d"] */
        "enrich.with_flow.time_periods"?: string[];
        /**
         * If you need to return the team members information, set this to true
         * @default false
         */
        "enrich.with_team"?: boolean;
        /**
         * If you need to return the investors information, set this to true
         * @default false
         */
        "enrich.with_investor"?: boolean;
        /**
         * If you need to return supporting exchanges list, set this to true
         * @default false
         */
        "enrich.with_exchange"?: boolean;
        /**
         * If you need to return the ticker information, set this to true
         * @default false
         */
        "enrich.with_ticker"?: boolean;
        /**
         * If you need to return just the 360 report list, set this to true
         * @default false
         */
        "enrich.with_rating"?: boolean;
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_sparkline.enable"?: boolean;
        /**
         * allowed values[1m, 15m, 1h]
         * @default "1m"
         */
        "enrich.with_sparkline.interval"?: string;
        /**
         * the number of trading days to query. Allowed values[1d , 5d , 7d, 30d]
         * @default "1d"
         */
        "enrich.with_sparkline.trading_period"?: string;
        /**
         * If you need to return the funding rate, set this to true
         * @default false
         */
        "enrich.with_funding_rate"?: boolean;
        /**
         * If you need to return the Stochastic information, set this to true.
         * @default false
         */
        "enrich.with_stochastic.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate Stochastic.
         * @format int32
         * @default 14
         */
        "enrich.with_stochastic.period"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %K.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_k"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %D.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_d"?: number;
        /**
         * If you need to return the Trend Analysis information, set this to true.
         * @default false
         */
        "enrich.with_trend_analysis.enable"?: boolean;
        /**
         * Optional. Default is 30. The number of data points used to calculate Trend Analysis.
         * @format int32
         * @default 30
         */
        "enrich.with_trend_analysis.time_period"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TokenPaginationResponse, any>({
        path: `/tokens/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pools = {
    /**
     * @description query pool
     *
     * @tags OpenPool
     * @name GetPools
     * @summary /pools
     * @request GET:/pools
     * @secure
     */
    getPools: (
      query?: {
        /**
         * offset
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @format int32
         * @max 20
         * @default 10
         */
        limit?: number;
        /** pool's ids comma-separated if querying more than 1 pool. */
        ids?: string[];
        /** pool's pair comma-separated if querying more than 1 pool. */
        pairs?: string[];
        /**
         * sort type
         * @default "DESC"
         */
        "sort.order"?: "ASC" | "DESC";
        /**
         * sort field
         * @default "MARKET_CAP"
         */
        "sort.field"?: TokenSortField;
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the markets information, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * Optional. Default is market_cap_change_percentage_24h.
         * @default "market_cap_change_percentage_24h"
         */
        "enrich.with_market.sort"?:
          | "volume"
          | "market_cap"
          | "price"
          | "market_cap_change_percentage_24h"
          | "last_updated";
        /**
         * If you need to return the sparkline information, set this to true.
         * @default false
         */
        "enrich.with_ohlc.enable"?: boolean;
        /**
         * On or after a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.start_time"?: number;
        /**
         * Before a specified unix timestamp in milliseconds.
         * @format int64
         */
        "enrich.with_ohlc.end_time"?: number;
        /**
         * Data aggregation time interval. Supported values [ 5m,1h,4h,12h,1d,1w ]
         * @default "1h"
         */
        "enrich.with_ohlc.interval"?: string;
        /** query conditions array */
        "query.conditions"?: OpenDataQueryCondition[];
        /**
         * query condition type
         * @default "AND"
         */
        "query.condition_type"?: "AND" | "OR";
      },
      params: RequestParams = {},
    ) =>
      this.request<PoolPaginationResponse, any>({
        path: `/pools`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stocks = {
    /**
     * @description query stocks
     *
     * @tags OpenStock
     * @name GetStocks
     * @summary /stocks
     * @request GET:/stocks
     * @secure
     */
    getStocks: (
      query?: {
        /**
         * The offset of the first item to return
         * @default 0
         */
        offset?: number;
        /**
         * The maximum number of items to return
         * @default 10
         */
        limit?: number;
        symbols?: string[];
        ids?: string[];
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /** If you need to return the asset must include types, set this to specific types. */
        "enrich.include_types"?: string[];
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_sparkline.enable"?: boolean;
        /**
         * allowed values[1m, 15m, 1h]
         * @default "1m"
         */
        "enrich.with_sparkline.interval"?: string;
        /**
         * the number of trading days to query. Allowed values[1d , 5d , 7d, 30d]
         * @default "1d"
         */
        "enrich.with_sparkline.trading_period"?: string;
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_trading_data"?: boolean;
        /**
         * If you need to return the price forecast, set this to true.
         * @default false
         */
        "enrich.with_target_price"?: boolean;
        /**
         * If you need to return the OHLCV information, set this to true.
         * @default false
         */
        "enrich.with_ohlcv.enable"?: boolean;
        /**
         * Data aggregation time interval. Supported values [ 1m,15m,1h,1d ]
         * @default "1d"
         */
        "enrich.with_ohlcv.interval"?: string;
        /**
         * Data aggregation time period. Supported values [ 1d,5d,7d,30d,365d ]
         * @default "1d"
         */
        "enrich.with_ohlcv.period"?: string;
        /**
         * If you need to return the recommendation trend, set this to true.
         * @default false
         */
        "enrich.with_recommendation_trend"?: boolean;
        /**
         * If you need to return the rating data, set this to true.
         * @default false
         */
        "enrich.with_rating"?: boolean;
        /**
         * Whether to return historical earnings data, defaults to past 12 quarters
         * @default false
         */
        "enrich.with_earnings.enable"?: boolean;
        /**
         * Earnings limit
         * @max 50
         * @default 10
         */
        "enrich.with_earnings.limit"?: number;
        /**
         * Whether to return revenue estimate data
         * @default false
         */
        "enrich.with_revenue_estimates.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_revenue_estimates.freq"?: FinancialFrequency;
        /**
         * Revenue data limit
         * @max 50
         * @default 10
         */
        "enrich.with_revenue_estimates.limit"?: number;
        /**
         * Whether to return earning quality score data
         * @default false
         */
        "enrich.with_earning_scores.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_earning_scores.freq"?: FinancialFrequency;
        /**
         * Earnings score limit
         * @max 50
         * @default 10
         */
        "enrich.with_earning_scores.limit"?: number;
        /**
         * Whether to return historical dividends data
         * @default false
         */
        "enrich.with_dividends.enable"?: boolean;
        /**
         * Dividends limit
         * @max 50
         * @default 10
         */
        "enrich.with_dividends.limit"?: number;
        /**
         * Whether to return financial data
         * @default false
         */
        "enrich.with_financials.enable"?: boolean;
        /**
         * Financial data limit
         * @max 50
         * @default 10
         */
        "enrich.with_financials.limit"?: number;
        /**
         * If you need to return the ttm data, set this to true.
         * @default false
         */
        "enrich.with_financials.ttm"?: boolean;
        /** Financial statement type, IC for income statement, BS for balance sheet, CF for cash flow statement */
        "enrich.with_financials.statements"?: ("IC" | "BS" | "CF")[];
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_financials.freq"?: FinancialFrequency;
        /**
         * Whether to return revenue breakdown data
         * @default false
         */
        "enrich.with_revenue_breakdown.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_revenue_breakdown.freq"?: FinancialFrequency;
        /** Group types, GEOGRAPHY for geography grouping, PRODUCT for product grouping */
        "enrich.with_revenue_breakdown.groups"?: ("GEOGRAPHY" | "PRODUCT")[];
        /**
         * If you need to return the Stochastic information, set this to true.
         * @default false
         */
        "enrich.with_stochastic.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate Stochastic.
         * @format int32
         * @default 14
         */
        "enrich.with_stochastic.period"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %K.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_k"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %D.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_d"?: number;
        /**
         * If you need to return the Trend Analysis information, set this to true.
         * @default false
         */
        "enrich.with_trend_analysis.enable"?: boolean;
        /**
         * Optional. Default is 30. The number of data points used to calculate Trend Analysis.
         * @format int32
         * @default 30
         */
        "enrich.with_trend_analysis.time_period"?: number;
        /** stock market */
        market?: StockMarketEnum;
        /** language code */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StockPaginationResponse, any>({
        path: `/stocks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query stocks
     *
     * @tags OpenStock
     * @name GetRankingStocks
     * @summary /stocks/ranking
     * @request GET:/stocks/ranking
     * @secure
     */
    getRankingStocks: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        themes?: string[];
        /** theme ids */
        theme_ids?: string[];
        theme?: string;
        /** sort type */
        "sort.order"?: "ASC" | "DESC";
        /** sort field */
        "sort.field"?: StockSortField;
        type?: "REPORT_360";
        /**
         * If you need to return the token relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /** If you need to return the asset must include types, set this to specific types. */
        "enrich.include_types"?: string[];
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_sparkline.enable"?: boolean;
        /**
         * allowed values[1m, 15m, 1h]
         * @default "1m"
         */
        "enrich.with_sparkline.interval"?: string;
        /**
         * the number of trading days to query. Allowed values[1d , 5d , 7d, 30d]
         * @default "1d"
         */
        "enrich.with_sparkline.trading_period"?: string;
        /**
         * If you need to return the trading data, set this to true.
         * @default false
         */
        "enrich.with_trading_data"?: boolean;
        /**
         * If you need to return the price forecast, set this to true.
         * @default false
         */
        "enrich.with_target_price"?: boolean;
        /**
         * If you need to return the OHLCV information, set this to true.
         * @default false
         */
        "enrich.with_ohlcv.enable"?: boolean;
        /**
         * Data aggregation time interval. Supported values [ 1m,15m,1h,1d ]
         * @default "1d"
         */
        "enrich.with_ohlcv.interval"?: string;
        /**
         * Data aggregation time period. Supported values [ 1d,5d,7d,30d,365d ]
         * @default "1d"
         */
        "enrich.with_ohlcv.period"?: string;
        /**
         * If you need to return the recommendation trend, set this to true.
         * @default false
         */
        "enrich.with_recommendation_trend"?: boolean;
        /**
         * If you need to return the rating data, set this to true.
         * @default false
         */
        "enrich.with_rating"?: boolean;
        /**
         * Whether to return historical earnings data, defaults to past 12 quarters
         * @default false
         */
        "enrich.with_earnings.enable"?: boolean;
        /**
         * Earnings limit
         * @max 50
         * @default 10
         */
        "enrich.with_earnings.limit"?: number;
        /**
         * Whether to return revenue estimate data
         * @default false
         */
        "enrich.with_revenue_estimates.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_revenue_estimates.freq"?: FinancialFrequency;
        /**
         * Revenue data limit
         * @max 50
         * @default 10
         */
        "enrich.with_revenue_estimates.limit"?: number;
        /**
         * Whether to return earning quality score data
         * @default false
         */
        "enrich.with_earning_scores.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_earning_scores.freq"?: FinancialFrequency;
        /**
         * Earnings score limit
         * @max 50
         * @default 10
         */
        "enrich.with_earning_scores.limit"?: number;
        /**
         * Whether to return historical dividends data
         * @default false
         */
        "enrich.with_dividends.enable"?: boolean;
        /**
         * Dividends limit
         * @max 50
         * @default 10
         */
        "enrich.with_dividends.limit"?: number;
        /**
         * Whether to return financial data
         * @default false
         */
        "enrich.with_financials.enable"?: boolean;
        /**
         * Financial data limit
         * @max 50
         * @default 10
         */
        "enrich.with_financials.limit"?: number;
        /**
         * If you need to return the ttm data, set this to true.
         * @default false
         */
        "enrich.with_financials.ttm"?: boolean;
        /** Financial statement type, IC for income statement, BS for balance sheet, CF for cash flow statement */
        "enrich.with_financials.statements"?: ("IC" | "BS" | "CF")[];
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_financials.freq"?: FinancialFrequency;
        /**
         * Whether to return revenue breakdown data
         * @default false
         */
        "enrich.with_revenue_breakdown.enable"?: boolean;
        /** Data frequency, quarterly for quarterly data, annual for annual data, ttm for trailing twelve months */
        "enrich.with_revenue_breakdown.freq"?: FinancialFrequency;
        /** Group types, GEOGRAPHY for geography grouping, PRODUCT for product grouping */
        "enrich.with_revenue_breakdown.groups"?: ("GEOGRAPHY" | "PRODUCT")[];
        /**
         * If you need to return the Stochastic information, set this to true.
         * @default false
         */
        "enrich.with_stochastic.enable"?: boolean;
        /**
         * Optional. Default is 14. The number of data points used to calculate Stochastic.
         * @format int32
         * @default 14
         */
        "enrich.with_stochastic.period"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %K.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_k"?: number;
        /**
         * Optional. Default is 3. The smoothing period for %D.
         * @format int32
         * @default 3
         */
        "enrich.with_stochastic.smooth_d"?: number;
        /**
         * If you need to return the Trend Analysis information, set this to true.
         * @default false
         */
        "enrich.with_trend_analysis.enable"?: boolean;
        /**
         * Optional. Default is 30. The number of data points used to calculate Trend Analysis.
         * @format int32
         * @default 30
         */
        "enrich.with_trend_analysis.time_period"?: number;
        /** JSON string for StockDynamicFilter */
        filters?: string[];
        /** stock market */
        market?: StockMarketEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<StockPaginationResponse, any>({
        path: `/stocks/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query stock market metrics
     *
     * @tags OpenStock
     * @name GetStockMarketMetrics
     * @summary /stocks/market/metrics
     * @request GET:/stocks/market/metrics
     * @secure
     */
    getStockMarketMetrics: (
      query?: {
        /** altcoin index (仅 crypto 使用，stock 目前不用) */
        with_altcoin_index?: boolean;
        /** whether to include Fear & Greed Index */
        with_fear_and_greed_index?: boolean;
        /** whether to include BTC / ETH dominance */
        with_dominance?: boolean;
        /** stock index symbols, deprecated */
        with_index_trading_data?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketMetricsResponse, any>({
        path: `/stocks/market/metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get market schedule
     *
     * @tags OpenStock
     * @name GetMarketSchedule
     * @summary /stocks/market/schedule
     * @request GET:/stocks/market/schedule
     * @secure
     */
    getMarketSchedule: (
      query: {
        /** stock market */
        market: StockMarketEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketScheduleResponse, any>({
        path: `/stocks/market/schedule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  market = {
    /**
     * @description query market metrics
     *
     * @tags OpenMarketPair
     * @name GetMarketMetrics
     * @summary /market/metrics
     * @request GET:/market/metrics
     * @secure
     */
    getMarketMetrics: (
      query?: {
        /** altcoin index (0-100) */
        with_altcoin_index?: boolean;
        /** whether to include Fear & Greed Index */
        with_fear_and_greed_index?: boolean;
        /** whether to include BTC / ETH dominance */
        with_dominance?: boolean;
        /** stock index symbols, deprecated */
        with_index_trading_data?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketMetricsResponse, any>({
        path: `/market/metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pairs = {
    /**
     * @description query market pairs for agents
     *
     * @tags OpenMarketPair
     * @name GetMarketPairsForAgents
     * @summary /pairs/agents
     * @request GET:/pairs/agents
     * @secure
     */
    getMarketPairsForAgents: (
      query?: {
        /**
         * offset
         * @format int32
         * @min 0
         * @max 20
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @format int32
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /** exchange */
        exchange?: ExchangeEnum;
        /**
         * If you need to return the pair relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the EMA information, set this to true.
         * @default false
         */
        "enrich.with_ema.enable"?: boolean;
        /** Optional. Default is 6. The number of data points used to calculate the EMA. */
        "enrich.with_ema.time_period"?: number[];
        /**
         * If you need to return the RSI information, set this to true.
         * @default false
         */
        "enrich.with_rsi.enable"?: boolean;
        /** Optional. Default is 14. The number of data points used to calculate RSI. Common values include 6, 12, and 24. */
        "enrich.with_rsi.time_period"?: number[];
        /**
         * If you need to return the MACD information, set this to true.
         * @default false
         */
        "enrich.with_macd.enable"?: boolean;
        /**
         * Optional. Default is 12. The number of data points used to calculate the fast EMA.
         * @format int32
         * @default 12
         */
        "enrich.with_macd.fast_period"?: number;
        /**
         * Optional. Default is 26. The number of data points used to calculate the slow EMA.
         * @format int32
         * @default 26
         */
        "enrich.with_macd.slow_period"?: number;
        /**
         * Optional. Default is 9. The number of data points used to calculate the signal line.
         * @format int32
         * @default 9
         */
        "enrich.with_macd.signal_period"?: number;
        /**
         * If you need to return the fractal point relative information, set this to true.
         * @default false
         */
        "enrich.with_fractal_point.enable"?: boolean;
        /**
         * size
         * @format int32
         * @min 1
         * @max 2
         * @default 2
         */
        "enrich.with_fractal_point.size"?: number;
        /** OHLC time range */
        "enrich.with_ohlc"?: "SHORT" | "MEDIUM" | "LONG";
        /**
         * If you need to return the markets information, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * Optional. Default is market_cap_change_percentage_24h.
         * @default "market_cap_change_percentage_24h"
         */
        "enrich.with_market.sort"?:
          | "volume"
          | "market_cap"
          | "price"
          | "market_cap_change_percentage_24h"
          | "last_updated";
        /** If you need to return volume data, set this to true */
        "enrich.with_volume"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketPairPaginationResponse, any>({
        path: `/pairs/agents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get market pair
     *
     * @tags OpenMarketPair
     * @name GetMarketPair
     * @summary /pairs/agents/{symbol}
     * @request GET:/pairs/agents/{symbol}
     * @secure
     */
    getMarketPair: (
      symbol: string,
      query?: {
        /**
         * If you need to return the pair relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the EMA information, set this to true.
         * @default false
         */
        "enrich.with_ema.enable"?: boolean;
        /** Optional. Default is 6. The number of data points used to calculate the EMA. */
        "enrich.with_ema.time_period"?: number[];
        /**
         * If you need to return the RSI information, set this to true.
         * @default false
         */
        "enrich.with_rsi.enable"?: boolean;
        /** Optional. Default is 14. The number of data points used to calculate RSI. Common values include 6, 12, and 24. */
        "enrich.with_rsi.time_period"?: number[];
        /**
         * If you need to return the MACD information, set this to true.
         * @default false
         */
        "enrich.with_macd.enable"?: boolean;
        /**
         * Optional. Default is 12. The number of data points used to calculate the fast EMA.
         * @format int32
         * @default 12
         */
        "enrich.with_macd.fast_period"?: number;
        /**
         * Optional. Default is 26. The number of data points used to calculate the slow EMA.
         * @format int32
         * @default 26
         */
        "enrich.with_macd.slow_period"?: number;
        /**
         * Optional. Default is 9. The number of data points used to calculate the signal line.
         * @format int32
         * @default 9
         */
        "enrich.with_macd.signal_period"?: number;
        /**
         * If you need to return the fractal point relative information, set this to true.
         * @default false
         */
        "enrich.with_fractal_point.enable"?: boolean;
        /**
         * size
         * @format int32
         * @min 1
         * @max 2
         * @default 2
         */
        "enrich.with_fractal_point.size"?: number;
        /** OHLC time range */
        "enrich.with_ohlc"?: "SHORT" | "MEDIUM" | "LONG";
        /**
         * If you need to return the markets information, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
        /**
         * Optional. Default is market_cap_change_percentage_24h.
         * @default "market_cap_change_percentage_24h"
         */
        "enrich.with_market.sort"?:
          | "volume"
          | "market_cap"
          | "price"
          | "market_cap_change_percentage_24h"
          | "last_updated";
        /** If you need to return volume data, set this to true */
        "enrich.with_volume"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketPairResponse, any>({
        path: `/pairs/agents/${symbol}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  search = {
    /**
     * @description Search project/people/token/pool/ecosystem/stock according to keywords @type SearchSingleOpenDataRequest
     *
     * @tags OpenData
     * @name Search
     * @summary /search
     * @request GET:/search
     * @secure
     */
    search: (
      query?: {
        /** open data type */
        type?: OpenDataTypeEnum;
        /** query keyword string */
        keyword?: string;
        /**
         * query operator
         * @default "MATCH"
         */
        operator?: "MATCH" | "PREFIX" | "EXACT";
        "query.conditions"?: OpenDataQueryCondition[];
        /** @default "AND" */
        "query.condition_type"?: "AND" | "OR";
        /**
         * query limit
         * @min 1
         * @max 20
         * @default 5
         */
        limit?: number;
        /**
         * query offset
         * @default 0
         */
        offset?: number;
        /** @default "en-US" */
        language?: string;
        market?: string;
        /** open data type */
        sub_type?: OpenDataTypeEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchOpenDataPaginationResponse, any>({
        path: `/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  searchGrouped = {
    /**
     * @description Search project/people/token/pool/ecosystem according to keywords by group @type SearchOpenDataRequest
     *
     * @tags OpenData
     * @name SearchGrouped
     * @summary /search-grouped
     * @request GET:/search-grouped
     * @secure
     */
    searchGrouped: (
      query?: {
        types?: OpenDataTypeEnum[];
        /** query keyword string */
        keyword?: string;
        /**
         * query operator
         * @default "MATCH"
         */
        operator?: "MATCH" | "PREFIX" | "EXACT";
        "query.conditions"?: OpenDataQueryCondition[];
        /** @default "AND" */
        "query.condition_type"?: "AND" | "OR";
        /**
         * query limit
         * @min 1
         * @max 20
         * @default 5
         */
        limit?: number;
        /** @default "en-US" */
        language?: string;
        market?: string;
        sub_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchOpenDataGroupResponse, any>({
        path: `/search-grouped`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  recommend = {
    /**
     * @description get recommend data by scopes
     *
     * @tags [object Object]
     * @name GetRecommend
     * @summary /recommend
     * @request GET:/recommend
     * @secure
     */
    getRecommend: (
      query: {
        /** related keyword or context */
        related?: string;
        /** related_condition[c1]=v1&related_condition[c2]=v2&related_condition[c2]=v3 */
        related_condition?: string;
        /** scope type and limit pairs, key is scope type, value is limit */
        scopes: Record<string, number>;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecommendResponse, any>({
        path: `/recommend`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get recommend data by scope
     *
     * @tags OpenRecommend
     * @name GetScopedRecommend
     * @summary /recommend/{scope}
     * @request GET:/recommend/{scope}
     * @secure
     */
    getScopedRecommend: (
      scope: string,
      query?: {
        /**
         * page offset
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * request data count
         * @max 20
         * @default 10
         */
        limit?: number;
        /** related keyword or context */
        related?: string;
        /** related_condition[c1]=v1&related_condition[c2]=v2&related_condition[c2]=v3 */
        related_condition?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecommendPaginationResponse, any>({
        path: `/recommend/${scope}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  portfolios = {
    /**
     * @description Get user's portfolios with filtering and pagination
     *
     * @tags Portfolio
     * @name GetPortfolios
     * @summary Get portfolios
     * @request GET:/portfolios
     * @secure
     */
    getPortfolios: (
      query?: {
        /** next token for pagination */
        next_token?: string;
        /**
         * limit number of portfolios
         * @min 1
         * @max 20
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioPaginationResponse, BaseResponse>({
        path: `/portfolios`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new portfolio
     *
     * @tags Portfolio
     * @name CreatePortfolio
     * @summary Create portfolio
     * @request POST:/portfolios
     * @secure
     */
    createPortfolio: (
      data: CreatePortfolioRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioResponse, any>({
        path: `/portfolios`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing portfolio
     *
     * @tags Portfolio
     * @name UpdatePortfolio
     * @summary Update portfolio
     * @request PUT:/portfolios
     * @secure
     */
    updatePortfolio: (
      data: UpdatePortfolioRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioResponse, any>({
        path: `/portfolios`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a portfolio
     *
     * @tags Portfolio
     * @name DeletePortfolio
     * @summary Delete portfolio
     * @request DELETE:/portfolios
     * @secure
     */
    deletePortfolio: (
      data: DeletePortfolioRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/portfolios`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user's Portfolio Asset with support for asset type and category filtering
     *
     * @tags PortfolioAsset
     * @name GetUserPortfolioAsset
     * @summary Get user PortfolioAsset
     * @request GET:/portfolios/asset
     * @secure
     */
    getUserPortfolioAsset: (
      query?: {
        /**
         * Asset IDs
         * @maxItems 20
         */
        asset_ids?: string[];
        /** Asset type filter */
        asset_type?: "TOKEN" | "STOCK";
        /** Data source category filter */
        category?: "REPORT_360";
        /** Portfolio ID */
        portfolio_id?: string;
        /** Search keyword */
        keyword?: string;
        /**
         * The amount of Portfolio Asset requested from the APIs
         * @max 20
         * @default 5
         */
        limit?: number;
        /** nextToken */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioAssetPaginationResponse, any>({
        path: `/portfolios/asset`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add Token or Stock assets to user's Portfolio Asset
     *
     * @tags PortfolioAsset
     * @name AddToPortfolioAsset
     * @summary Add to Portfolio Asset
     * @request POST:/portfolios/asset
     * @secure
     */
    addToPortfolioAsset: (
      data: AddPortfolioAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/portfolios/asset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove specified asset from user's PortfolioAsset
     *
     * @tags PortfolioAsset
     * @name RemoveFromPortfolioAsset
     * @summary Remove from PortfolioAsset
     * @request DELETE:/portfolios/asset
     * @secure
     */
    removeFromPortfolioAsset: (
      data: RemovePortfolioAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/portfolios/asset`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description /portfolios/asset
     *
     * @tags PortfolioAsset
     * @name GetUserPortfolioAsset2
     * @summary Get user PortfolioAsset
     * @request GET:/portfolios/asset/ids
     * @originalName getUserPortfolioAsset
     * @duplicate
     * @secure
     */
    getUserPortfolioAsset2: (
      query: {
        /**
         * Asset IDs
         * @maxItems 20
         */
        asset_ids: string[];
        /** Asset type */
        asset_type: PortfolioAssetTypeEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioAssetPaginationResponse, any>({
        path: `/portfolios/asset/ids`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  forexes = {
    /**
     * @description Get forex
     *
     * @tags OpenForex
     * @name GetForexes
     * @summary Get forex
     * @request GET:/forexes
     * @secure
     */
    getForexes: (
      query?: {
        /**
         * offset
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @format int32
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /** forex ids */
        ids?: string[];
        /**
         * If you need to return the forex relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * If you need to return the market data, set this to true.
         * @default false
         */
        "enrich.with_market.enable"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ForexPaginationResponse, any>({
        path: `/forexes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  etf = {
    /**
     * @description get etf profile
     *
     * @tags OpenEtf
     * @name GetProfile
     * @summary /etf/{symbol}/profile
     * @request GET:/etf/{symbol}/profile
     * @secure
     */
    getProfile: (
      symbol: string,
      query?: {
        /**
         * Language code for multi-language fields (e.g. en-US, zh-CN)
         * @default "en-US"
         */
        language?: string;
        /**
         * If you need to return the performance returns data, set this to true.
         * @default false
         */
        "enrich.with_performance"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<EtfProfileResponse, any>({
        path: `/etf/${symbol}/profile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get etf holdings overview
     *
     * @tags OpenEtf
     * @name GetHoldingsOverview
     * @summary /etf/{symbol}/holdings/overview
     * @request GET:/etf/{symbol}/holdings/overview
     * @secure
     */
    getHoldingsOverview: (
      symbol: string,
      query?: {
        /**
         * Language code for multi-language fields
         * @default "en-US"
         */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EtfHoldingsOverviewResponse, any>({
        path: `/etf/${symbol}/holdings/overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get etf holdings with pagination
     *
     * @tags OpenEtf
     * @name ListHoldings
     * @summary /etf/{symbol}/holdings
     * @request GET:/etf/{symbol}/holdings
     * @secure
     */
    listHoldings: (
      symbol: string,
      query?: {
        /**
         * Page size
         * @default 20
         */
        limit?: number;
        /** Cursor for next page */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EtfHoldingsPaginationResponse, any>({
        path: `/etf/${symbol}/holdings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stock = {
    /**
     * @description get split history with pagination
     *
     * @tags OpenStock
     * @name ListSplits
     * @summary /stock/{symbol}/splits
     * @request GET:/stock/{symbol}/splits
     * @secure
     */
    listSplits: (
      symbol: string,
      query?: {
        /**
         * Page size
         * @default 20
         */
        limit?: number;
        /** Cursor for next page */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StockSplitPaginationResponse, any>({
        path: `/stock/${symbol}/splits`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get dividend history with pagination
     *
     * @tags OpenStock
     * @name ListDividends
     * @summary /stock/{symbol}/dividends
     * @request GET:/stock/{symbol}/dividends
     * @secure
     */
    listDividends: (
      symbol: string,
      query?: {
        /**
         * Page size
         * @default 20
         */
        limit?: number;
        /** Cursor for next page */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DividendPaginationResponse, any>({
        path: `/stock/${symbol}/dividends`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  peoples = {
    /**
     * @description query people; when querying by ids or handles, category is not required
     *
     * @tags OpenPeople
     * @name GetPeoples
     * @summary /peoples
     * @request GET:/peoples
     * @secure
     */
    getPeoples: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @max 20
         * @default 10
         */
        limit?: number;
        /** people' IDs, comma-separated if querying more than 1 people. */
        ids?: string[];
        /** people' handles, comma-separated if querying more than 1 people. */
        handles?: string[];
        "query.conditions"?: OpenDataQueryCondition[];
        /** @default "AND" */
        "query.condition_type"?: "AND" | "OR";
        /**
         * If you need to return the people relative information, set this to true.
         * @default false
         */
        "enrich.enable"?: boolean;
        /**
         * fill x's posts count
         * @min 0
         * @max 20
         * @default 0
         */
        "enrich.with_x_content_count"?: number;
        /** include some social metrics, such as ... */
        "enrich.with_social_metrics"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PeoplePaginationResponse, any>({
        path: `/peoples`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  portfolio = {
    /**
     * @description Multimodal LLM parses financial documents (screenshots/PDF) and returns structured financial records. Supports POSITION_ASSET, POSITION_ORDER, ACCOUNT_BALANCE, BANK_TRANSACTION, LIABILITY, OTHER_ASSET. Response includes `records` (primary) and legacy `holdings` (POSITION_ASSET only).
     *
     * @tags Portfolio
     * @name PostPortfolioRecognize
     * @summary /portfolio/recognize
     * @request POST:/portfolio/recognize
     * @secure
     */
    postPortfolioRecognize: (
      data: PortfolioRecognizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioRecognizeResponse, PortfolioRecognizeResponse>({
        path: `/portfolio/recognize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Persists recognized financial data to Financial Planner (MANUAL accounts). Accepts `records` (preferred) or legacy `holdings`. Returns per-record save status.
     *
     * @tags Portfolio
     * @name PostPortfolioSave
     * @summary /portfolio/save
     * @request POST:/portfolio/save
     */
    postPortfolioSave: (
      data: PortfolioSaveRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioSaveResponse, PortfolioSaveResponse>({
        path: `/portfolio/save`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
